import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { createPortal } from 'react-dom';
// import { useTranslation } from 'react-i18next'; // Imported below
import { useTranslation } from 'react-i18next';
// 🎯 [Refactor] Import styled components from separate file
import {
  THEME, Container, RippleContainer, RippleCircle, HeaderArea, StickyNav, TopBar,
  MapToggleButton, SearchButton, NotificationButton, RedDot, PiLoginButton, ScanButton,
  UserBadge, PointText, ProgressBar, ControlsContainer, DistanceChip, TabsHeader, Tab,
  FeedList, SpotCard, CardHeader, TypeBadge, Distance, CardBody, CardTextColumn, CardImageColumn,
  SpotThumbnail, CardTitle, CardContent, CardFooter, VerificationInfo, FloatingAddBtn, EmptyState,
  ModalOverlay, ModalContent, ModalMessage, ModalActions, ModalButton, RegModalContent,
  RegTypeContainer, RegTypeButton, SlotBadge, RegInput, RegTextArea, RadarContainer, RadarScreen, FadeGradient,
  RadarSweep, RadarBlip, RadarStatusText, CenterAvatarContainer, CenterAvatarImg,
  RadarHandle, ImageUploadPlaceholder,
  DetailModalOverlay, DetailModalContent, DetailHeader, DetailBody, DetailFooter,
  CommentSection, CommentList, CommentItem, CommentInputBox, LikeButton, AuthButton,
  FlexRow, FlexColumn, CenteredContainer, RelativeContainer
} from './styles/SpotStyles';
import SPOT_CONSTANTS from './constants/SpotConstants';
import SPOT_MESSAGES from './constants/SpotMessages';
import useAchievementToast from '../../hooks/useAchievementToast.js'; // 🎯 [New] Achievement Toast Hook

// 🎯 [Spot Go MVP] Landmark visit system modules
import useLandmarkManager from './hooks/useLandmarkManager';
import LandmarkActionUI from './components/LandmarkActionUI';
import TopRankSection from './components/TopRankSection';

import { IoLocationSharp, IoAdd, IoHeart, IoHeartOutline, IoShieldCheckmark, IoMapOutline, IoPerson, IoChevronUp, IoChevronDown, IoStar, IoClose, IoExpand, IoContract, IoSync, IoSwapVertical, IoArrowUp, IoNotifications, IoWifi, IoChatbubbleOutline, IoCheckmark, IoLockClosed, IoBusiness, IoTimeOutline, IoWarning, IoLocate } from 'react-icons/io5';
import SpotCoinIcon from '../../components/common/SpotCoinIcon';

import { collection, getDocs, orderBy, query, limit, where, doc, getDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase';
import { useAppContext, APP_MODE } from '../../contexts/AppContext';

import { LocationService } from '../../services/LocationService';
import { SpotService } from '../../services/SpotService';
import { useSpotController } from './hooks/useSpotController'; // 🎯 [NEW] Controller Hook
import { usePointSpotController } from './hooks/usePointSpotController'; // 🎯 [NEW] Point Spot Hook
import { useImageUpload } from './hooks/useImageUpload'; // 🎯 [NEW] Image Upload Hook
import { useSpotLocation } from './hooks/useSpotLocation';
import { usePremiumRadius } from './hooks/usePremiumRadius'; // 🎯 [NEW] Premium Radius Hook
import { useTreasureHuntMode } from './hooks/useTreasureHuntMode'; // 🎯 [NEW] Treasure Hunt Mode Hook
import TreasureHuntOverlay from './components/TreasureHuntOverlay';
import useWalkSession from '../../features/walk/useWalkSession';
import { WALK_RETURN_PENDING, WALK_START_PENDING } from '../../features/walk/constants';
import CityModal from '../../features/city/CityModal';
import CityIcon from '../../components/common/CityIcon';
import { CITY_KEYS } from '../../features/city/constants';
import BaseList from '../../features/base/components/BaseList';
import BaseLeafletMap from '../../features/base/components/BaseLeafletMap';
import useBaseManager from '../../features/base/hooks/useBaseManager';
import { BASE_KEYS, estimateHourlySpot } from '../../features/base/constants';
import { getCityNameKey } from '../../features/city/constants';
import SpotDetailModal from './components/SpotDetailModal'; // 🎯 [NEW] Detail Modal Component
import PointSpotRewardModal from './components/PointSpotRewardModal'; // 🎯 [NEW] Reward Modal Component
import PremiumRadiusModal from './components/PremiumRadiusModal'; // 🎯 [NEW] Premium Radius Modal
import LandmarkDetailModal from './components/LandmarkDetailModal'; // 🎯 [Phase 4] Landmark Modal
import CurrencyModal from './components/CurrencyModal'; // 🎯 [NEW] Currency Modal Component
import AnnouncementListModal from '../../components/AnnouncementListModal'; // 🎯 [NEW] Announcement Modal
import TreasureHuntButton from './components/TreasureHuntButton';
import ReferralModal from '../../features/referral/ReferralModal';
import { REFERRAL_KEYS } from '../../features/referral/constants';
import { useAnnouncementsFirestore } from '../../hooks/useAnnouncementsFirestore'; // 🎯 [NEW] Announcements Hook
import { getLocalizedTitle, getLocalizedContent } from './utils/spotUtils'; // 🎯 [Import] Localization Utils
import UnifiedMapView from '../../components/map/UnifiedMapView';

import PiAdapter from '../../adapters/PiAdapter';
import { handleIncompletePayment } from '../../utils/paymentRecovery'; // 🎯 [결제 복구] 미완료 결제 즉시 처리
import { maskNickname } from '../../utils/maskNickname';
import { distanceBetween } from 'geofire-common';
// import PiAdService from '../../services/PiAdService'; // 🎯 [Removed] Unused directly
// import usePiAds from '../../hooks/usePiAds'; // 🎯 [Removed] Use Context function
import LoadingOverlay from '../../components/common/LoadingOverlay'; // 🎯 [NEW] Unified Loading

// 🎯 [ToS] Legal Document Imports
import { getCurrentTerms, getCurrentPrivacy, getCurrentLocation, LEGAL_VERSIONS } from '../../data/legal';

// 🎯 [Helper] Environment-aware Collection Path
const getCollectionPath = (base, env) => {
  if (!env || env === 'production' || env === 'mainnet') return base;
  if (env === 'sandbox') return base; // 🎯 [Revert] Sandbox uses root
  if (env === 'testnet') return `testnet_${base}`;
  return `dev_${base}`;
};

// 🛠️ [DEBUG] Expose for console access - Remove in production
window.LocationService = LocationService;


// [Leaflet Config Removed]

// [createCustomIcon Removed]

// [SVGs Removed]

// [Icons Removed]

// 🎯 [Refactor] THEME moved to styles/SpotStyles.js
// ... (omitted)

// 🎯 [NEW] Relative Time Helper Function
const getRelativeTime = (date) => {
  if (!date) return '';
  const now = new Date();
  const target = date instanceof Date ? date : (date.toDate ? date.toDate() : new Date(date));
  const diff = Math.floor((now - target) / 1000); // seconds

  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d`;

  // More than 7 days: show date
  return target.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

// [MapController Removed]

// --- Global Loading Overlay Removed (Imported from common) ---

const SpotGoMain = ({ piUser, processPiPayment, userPoints, onMenuClick: _onMenuClick, onNavigate, spotTabActive = true }) => {
  const { t, i18n } = useTranslation();
  const {
    environment, spendPpPoints, ticketCount, setTicketCount, savedAgreements,
    setAppMode, setHeavyTaskState, // 🎯 [Add] heavy task control
    watchAdForSpot, watchAdForPointSpot, watchAdForLandmarkVisit, // 🎯 [Add] watchAdForPointSpot
    spotPoints, setSpotPoints, authState, // 🎯 [Add] authState
    myLandSlots, myLandRegistrations, setMyLandRegistrations, purchaseMyLandSlot, registerMyLand, myLandCapture, renameMyLand,
    ppPoints,
    setPpPoints
  } = useAppContext();

  // const { showAd, isLoading: isAdLoading } = usePiAds(); // 🎯 [Removed] Use Context function instead

  // 🎯 [NEW] useSpotLocation Hook - GPS 권한 저장 기능 포함
  const {
    myPos,
    permissionStatus,
    permissionModal,
    setPermissionModal,
    locationSource,
    gpsToast,
    runInitialScanStrategy,

    isModalReady, // 🎯 [Fix] Prevent modal flash on mount
    isCheckingDb, // 🎯 [UI] DB 권한 로딩 중 상태
    setLocationTitle // 🎯 [Fix] "나중에" 버튼 오류 수정
  } = useSpotLocation(piUser);

  // 🎯 [NEW] Premium Radius Hook Integration
  const {
    isUnlocked: isPremiumUnlocked,
    timeLeft: premiumTimeLeft,
    unlock: unlockPremiumRadius,
    checkStatus: checkPremiumStatus
  } = usePremiumRadius();

  // 🎯 [NEW] Premium Modal State
  const [showPremiumModal, setShowPremiumModal] = useState(false);

  const isTestnet = environment === 'testnet' || environment === 'sandbox';

  // 🎯 [ToS 제거됨] 약관 동의는 App.js의 TosAgreementModal에서 처리

  // 🎯 [Hybrid Map] 한국 지역 판별 (GPS 기반) + [Dev Mode] Manual Switch
  const [viewState] = useState({ center: null, zoom: null }); // 🎯 [ViewState Lifting]
  const [useKakaoMap, setUseKakaoMap] = useState(() => {
    try {
      const cached = JSON.parse(localStorage.getItem('last_known_pos'));
      if (cached && Number.isFinite(cached.lat) && Number.isFinite(cached.lng)) {
        return (cached.lat >= 33 && cached.lat <= 39) && (cached.lng >= 124 && cached.lng <= 132);
      }
    } catch (_) { /* ignore */ }
    return true;
  });
  const [mapTarget, setMapTarget] = useState(null); // [lat, lng, timestamp] for forcing map center
  const mapRef = useRef(null); // 🎯 [NEW] 지도 인스턴스 참조 (내 위치 버튼용)

  // 🎯 [NEW] 내 위치로 중앙 이동
  const handleCenterToMyLocation = React.useCallback(() => {
    if (!myPos) {
      // 🎯 [Alert] GPS 정보 없음
      // 사용자가 이해하기 쉬운 메시지로 알림
      // (showAlert 함수가 있다면 사용)
      console.warn('GPS 정보가 없습니다.');
      return;
    }

    if (mapRef.current) {
      const myPosLatLng = new window.naver.maps.LatLng(myPos.lat, myPos.lng);
      mapRef.current.panTo(myPosLatLng, {
        duration: 500,
        easing: 'easeOutCubic'
      });
      // 🎯 [Tracking] Re-enable tracking mode
      if (mapRef.current.setTrackingMode) {
        mapRef.current.setTrackingMode(true);
      }
    }
  }, [myPos]);

  useEffect(() => {
    // 1. Check Dev Manual Override
    const devMapMode = localStorage.getItem('dev_map_manual'); // 'auto', 'naver', 'leaflet'
    if (devMapMode === 'naver') {
      setUseKakaoMap(true);
      return;
    }
    if (devMapMode === 'leaflet') {
      setUseKakaoMap(false);
      return;
    }

    // 2. Strict Geo-Fencing (Auto) based on Viewing Target OR My Position
    // If user is looking at a specific location (mapTarget or viewState.center), use that.
    // Otherwise use myPos.
    const target = viewState.center ? { lat: viewState.center.lat, lng: viewState.center.lng } :
      (mapTarget ? {
        lat: typeof mapTarget === 'object' && !Array.isArray(mapTarget) ? mapTarget.lat : mapTarget[0],
        lng: typeof mapTarget === 'object' && !Array.isArray(mapTarget) ? mapTarget.lng : mapTarget[1]
      } : myPos);

    if (target && target.lat && target.lng) {
      // 한국 대략적 범위: 위도 33~39, 경도 124~132
      const isKr = (target.lat >= 33 && target.lat <= 39) && (target.lng >= 124 && target.lng <= 132);
      setUseKakaoMap(isKr);
    }
  }, [myPos, mapTarget, viewState.center]); // Update when position or view center changes

  // 🎯 [NEW] Treasure Hunt Mode Hook
  const { isTreasureHuntMode, exitTreasureHuntMode, enterTreasureHuntMode } = useTreasureHuntMode({ myPos, setMapTarget });
  const [walkSessionActive, setWalkSessionActive] = useState(false);
  const walkSessionRef = useRef(false);
  const [isWalkLaunching, setIsWalkLaunching] = useState(() => {
    try { return sessionStorage.getItem(WALK_START_PENDING) === '1'; } catch (_) { return false; }
  });
  const [showCityModal, setShowCityModal] = useState(false);
  const [hasOpenedCityModal, setHasOpenedCityModal] = useState(false);

  useEffect(() => {
    if (showCityModal) setHasOpenedCityModal(true);
  }, [showCityModal]);

  const finishWalkSession = useCallback((shouldReturnToApps) => {
    let wasWalk = walkSessionRef.current;
    try {
      if (sessionStorage.getItem(WALK_START_PENDING) === '1') wasWalk = true;
      sessionStorage.removeItem(WALK_START_PENDING);
    } catch (_) { /* ignore */ }
    if (wasWalk) {
      walkSessionRef.current = false;
      setWalkSessionActive(false);
      try { sessionStorage.setItem(WALK_RETURN_PENDING, '1'); } catch (_) { /* ignore */ }
    }
    setIsWalkLaunching(false);
    if (shouldReturnToApps) onNavigate?.('apps');
  }, [onNavigate]);

  useEffect(() => {
    if (spotTabActive === false) return;
    let pending = false;
    try {
      pending = sessionStorage.getItem(WALK_START_PENDING) === '1';
    } catch (_) { return; }
    if (!pending) return;

    setIsWalkLaunching(true);
    if (!Number.isFinite(myPos?.lat) || !Number.isFinite(myPos?.lng)) return;

    try { sessionStorage.removeItem(WALK_START_PENDING); } catch (_) { /* ignore */ }
    walkSessionRef.current = true;
    setWalkSessionActive(true);
    setIsWalkLaunching(false);
    enterTreasureHuntMode();
  }, [spotTabActive, myPos, enterTreasureHuntMode]);

  useEffect(() => {
    if (spotTabActive === false || !isWalkLaunching || isTreasureHuntMode) return;
    const timer = setTimeout(() => {
      try {
        if (sessionStorage.getItem(WALK_START_PENDING) !== '1') return;
        sessionStorage.removeItem(WALK_START_PENDING);
      } catch (_) { return; }
      walkSessionRef.current = true;
      setWalkSessionActive(true);
      setIsWalkLaunching(false);
      enterTreasureHuntMode();
    }, 12000);
    return () => clearTimeout(timer);
  }, [spotTabActive, isWalkLaunching, isTreasureHuntMode, enterTreasureHuntMode]);

  useEffect(() => {
    if (spotTabActive !== false) return;
    if (!walkSessionRef.current && !isTreasureHuntMode && !isWalkLaunching) return;
    if (isTreasureHuntMode) exitTreasureHuntMode();
    finishWalkSession(false);
  }, [spotTabActive, isTreasureHuntMode, isWalkLaunching, exitTreasureHuntMode, finishWalkSession]);

  useEffect(() => {
    if (spotTabActive === false) return;
    const timer = setTimeout(() => {
      try {
        if (mapRef.current && window.naver?.maps?.Event) {
          window.naver.maps.Event.trigger(mapRef.current, 'resize');
        }
      } catch (_) { /* ignore */ }
    }, 300);
    return () => clearTimeout(timer);
  }, [spotTabActive]);

  useEffect(() => () => {
    if (walkSessionRef.current) {
      try { sessionStorage.setItem(WALK_RETURN_PENDING, '1'); } catch (_) { /* ignore */ }
    }
  }, []);

  useWalkSession({
    enabled: isTreasureHuntMode && walkSessionActive && spotTabActive !== false,
    uid: piUser?.uid,
    position: myPos
  });

  // 🌍 [2026-05-09] World Tour 메뉴 → "CITY 장착" CTA 진입 시 자동 오픈
  // sessionStorage 플래그('open_city_modal')는 1회 사용 후 즉시 제거하여 재진입 시 재오픈 방지
  useEffect(() => {
    try {
      if (sessionStorage.getItem('open_city_modal') === '1') {
        sessionStorage.removeItem('open_city_modal');
        setShowCityModal(true);
      }
    } catch (_) { /* sessionStorage 미지원 환경 무시 */ }
  }, []);

  // 🎯 [NEW] Point Spot Reward Modal State (usePointSpotController moved below useSpotController so we can pass landmarks)
  const [showPointSpotModal, setShowPointSpotModal] = useState(false);
  const [selectedPointSpot, setSelectedPointSpot] = useState(null);
  const [isClaimingPoint, setIsClaimingPoint] = useState(false);

  // 🎯 [NEW] Track claimed spots locally (Persistent per day)
  const [claimedSpotIds, setClaimedSpotIds] = useState(() => {
    try {
      if (!piUser) return new Set();
      const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
      const key = `claimed_spots_${piUser.uid}_${today}`;
      const saved = localStorage.getItem(key);
      return saved ? new Set(JSON.parse(saved)) : new Set();
    } catch (e) {
      return new Set();
    }
  });

  // 🎯 Save claimed spots to LocalStorage whenever it changes
  useEffect(() => {
    if (!piUser) return;
    try {
      const today = new Date().toISOString().split('T')[0];
      const key = `claimed_spots_${piUser.uid}_${today}`;
      localStorage.setItem(key, JSON.stringify(Array.from(claimedSpotIds)));
    } catch (e) {
      console.warn('Failed to save claimed spots:', e);
    }
  }, [claimedSpotIds, piUser]);
  const handlePointSpotClick = (spot) => {
    // Only allow clicking if close enough (e.g. 100m)? 
    // Or just allow clicking visible ones?
    // Let's implement distance check later if needed. For now, just open modal.
    setSelectedPointSpot(spot);
    setShowPointSpotModal(true);
  };

  // 🎯 [NEW] Claim Handlers
  const handleClaimPointSpot = async (type) => { // type: 'basic' | 'ad'
    if (!piUser) return showAlert(t(SPOT_MESSAGES.LOGIN_REQUIRED));
    if (isClaimingPoint) return;

    setIsClaimingPoint(true);

    try {
      // 1. Ad Flow (Integrated with AppContext)
      if (type === 'ad') {
        // 🎯 [Modularization] Use watchAdForPointSpot (Handles Premium Skip, Correct API & No Shop Cooldown)
        await new Promise((resolve, reject) => {
          watchAdForPointSpot(
            selectedPointSpot, // Pass full spot info (contains landmark info)
            (earnedAmount) => {
              // Success
              const msg = t('giftbox_claim_success_double', { amount: earnedAmount });
              showAlert(msg);
              // 🎯 [Fix] 즉시 지도의 선물상자 제거
              if (selectedPointSpot?.id) {
                setClaimedSpotIds(prev => new Set([...prev, selectedPointSpot.id]));
              }
              setShowPointSpotModal(false); // Close Modal on success
              resolve();
            },
            (errorMsg) => {
              // Error
              if (errorMsg !== 'AD_CLOSED_BY_USER') {
                // errorLog handled in watchAdForPointSpot
              }
              reject(new Error(errorMsg));
            }
          );
        });
      }
      // 2. Basic Flow (No Ad) — 일반/랜드마크 동일 API, options만 구분
      else {
        const claimType = selectedPointSpot?.isLandmarkPointSpot ? 'landmark' : 'basic';
        const claimOpts = selectedPointSpot?.isLandmarkPointSpot
          ? { landmarkId: selectedPointSpot.landmarkId, spotIndex: selectedPointSpot.spotIndex }
          : undefined;
        const result = await SpotService.claimPointSpot(claimType, null, piUser, environment, claimOpts);

        if (result.success) {
          const msg = t('giftbox_claim_success', { amount: result.amount });
          showAlert(msg);
          if (selectedPointSpot?.id) setClaimedSpotIds(prev => new Set([...prev, selectedPointSpot.id]));
          setShowPointSpotModal(false);
        }
      }

    } catch (e) {
      console.error('[SpotGoMain] Claim failed:', e);
      if (e.message !== 'AD_CLOSED_BY_USER') {
        // showAlert(t('claim_failed')); 
      }
    } finally {
      setIsClaimingPoint(false);
    }
  };

  // 🎯 [NEW] Controller Integration
  const {
    spots,
    allSpots, // 🎯 [Fix] TOP 5는 필터링되지 않은 전체 데이터 사용
    loading,
    hasEverLoaded,
    filterMode, setFilterMode, // activeTab replacement
    radius, setRadius, // distanceRadius replacement
    sortBy, setSortBy, // 🎯 [Sync] Controller의 정렬 상태 사용
    refreshSpots,
    setUserLocation, // Added for location sync
    setIsLocationReady, // Added for location sync
    updateSpot, // 🎯 [Sync] 리스트 상태 업데이트용
    clearSpotsCache // 🎯 [NEW] 캐시 클리어 함수
  } = useSpotController({
    piUser,
    environment // 🎯 [New] Pass Environment
  });

  useEffect(() => {
    if (!hasEverLoaded) return;
    window.dispatchEvent(new Event('painori-spot-boot-ready'));
  }, [hasEverLoaded]);

  const baseManager = useBaseManager({ piUser, environment, onTicketCountChange: setTicketCount });
  const isBaseMode = filterMode === 'base';
  const [mapPanCityId, setMapPanCityId] = useState(null);

  // 🎯 [Bridge] Sync location from useSpotLocation to useSpotController
  useEffect(() => {
    if (myPos) {
      setUserLocation(myPos);
      setIsLocationReady(true);
    }
  }, [myPos, setUserLocation, setIsLocationReady]);

  // 보물찾기도 SpotContext가 이미 조회한 랜드마크를 공유한다.
  // GPS 업데이트마다 동일 반경을 다시 읽지 않으면서 위치 추적과 보상 판정은 그대로 유지한다.
  const landmarksForPointSpots = useMemo(() => {
    if (!isTreasureHuntMode) return [];
    const byId = new Map();
    (allSpots || []).forEach((spot) => {
      const lat = spot.geo?.lat ?? spot.geo?.latitude;
      const lng = spot.geo?.lng ?? spot.geo?.longitude;
      if (
        spot.type === 'landmark'
        && spot.id
        && Number.isFinite(myPos?.lat)
        && Number.isFinite(myPos?.lng)
        && Number.isFinite(lat)
        && Number.isFinite(lng)
        && distanceBetween([myPos.lat, myPos.lng], [lat, lng]) * 1000 <= radius
        && !byId.has(spot.id)
      ) {
        byId.set(spot.id, spot);
      }
    });
    return Array.from(byId.values()).sort((a, b) => a.id.localeCompare(b.id));
  }, [isTreasureHuntMode, allSpots, myPos?.lat, myPos?.lng, radius]);

  const { pointSpots } = usePointSpotController(isTreasureHuntMode ? myPos : null, { landmarks: landmarksForPointSpots });

  // 🎯 [NEW] Image Upload Hook
  const { uploadImages, uploading: isUploadingImages } = useImageUpload();

  // Legacy State Mappings (to minimize UI code changes)
  const activeTab = filterMode;
  const setActiveTab = setFilterMode;
  const distanceRadius = radius;
  // const setDistanceRadius = setRadius; // Unused
  const handleScan = (newRadius) => {
    const radiusToUse = newRadius || radius;
    if (newRadius && newRadius !== radius) {
      setRadius(newRadius);
    }
    refreshSpots(radiusToUse);
  };

  const [topStores, setTopStores] = useState([]);
  // 저장된 지도 선택은 사용자가 직접 바꿨을 때만 따른다. 없으면 레이더가 먼저다.
  const [viewMap, setViewMap] = useState(() => {
    try {
      if (sessionStorage.getItem('spot_view_map_chosen') !== '1') return false;
      return JSON.parse(sessionStorage.getItem('spot_view_map')) === true;
    } catch (_) { return false; }
  });
  const rememberMapChoice = (next) => {
    setViewMap(next);
    try {
      sessionStorage.setItem('spot_view_map_chosen', '1');
      sessionStorage.setItem('spot_view_map', JSON.stringify(next));
    } catch (_) { /* ignore */ }
  };
  const [visibleCount, setVisibleCount] = useState(10);
  // const [loadTrigger, setLoadTrigger] = useState(null); // Unused
  const [radarRotation, setRadarRotation] = useState(0);
  const [touchStartAngle, setTouchStartAngle] = useState(null);
  const [isMapExpanded, setIsMapExpanded] = useState(false);
  const [topListTab, setTopListTab] = useState('stores');

  // 🎯 [Sync] 하단 탭(ALL/LANDMARK/BASE/STORE) 변경 시 상단 랭킹 탭 동기화
  useEffect(() => {
    const map = { all: 'landmarks', landmark: 'landmarks', store: 'stores', base: 'bases' };
    const top = map[filterMode];
    if (top) setTopListTab(top);
  }, [filterMode]);

  // const [sortOrder, setSortOrder] = useState('distance'); // 🎯 [Removed] Use Controller State
  const [showSortPopup, setShowSortPopup] = useState(false);
  const [showMySpotMenu, setShowMySpotMenu] = useState(false); // 🎯 [NEW] My Spot Dropdown
  const [mySpotFilter, setMySpotFilter] = useState(null); // null | 'my_posts' | 'my_comments' | 'my_store' | 'my_land'
  const mySpotMenuButtonRef = useRef(null); // 🎯 [Fix] Reference for dropdown positioning
  const [selectedMapSpotId, setSelectedMapSpotId] = useState(null);
  // Moved up to fix ReferenceError
  const [offScreenIndicator, setOffScreenIndicator] = useState({ angle: null, distance: null });
  const [modalSheetState, setModalSheetState] = useState('peek');
  const modalTouchY = useRef(null);

  useEffect(() => {
    if (!isBaseMode || spotTabActive === false) return;
    if (baseManager.cityLoading) return; // cityConfig 로드 전에는 skip (로드 완료 시 재호출)
    setShowSortPopup(false);
    setShowMySpotMenu(false);
    // BASE 탭 진입 및 cityConfig 로드 완료 시 최신 점유 현황 갱신
    baseManager.refresh();
  }, [isBaseMode, spotTabActive, baseManager.cityLoading]); // eslint-disable-line react-hooks/exhaustive-deps

  // BASE 탭 체류 중 다중 유저 변화 반영을 위한 주기적 갱신 (5분)
  // - 백그라운드(탭 숨김) 시 skip하여 불필요한 API 호출 최소화
  const baseRefresh = baseManager.refresh;
  useEffect(() => {
    if (!isBaseMode || spotTabActive === false) return;
    const id = setInterval(() => {
      if (document.visibilityState === 'visible') {
        baseRefresh();
      }
    }, 5 * 60 * 1000);
    return () => clearInterval(id);
  }, [isBaseMode, spotTabActive, baseRefresh]);

  const myBaseChips = useMemo(() => {
    const toMs = (value) => {
      if (!value) return 0;
      if (typeof value.toMillis === 'function') return value.toMillis();
      if (value.seconds != null) return value.seconds * 1000;
      if (value._seconds != null) return value._seconds * 1000;
      if (typeof value === 'number') return value;
      if (typeof value === 'string') {
        const parsed = Date.parse(value);
        return Number.isFinite(parsed) ? parsed : 0;
      }
      return 0;
    };
    const max = baseManager.config?.maxBasesPerUser || 3;
    const now = Date.now();
    const active = (baseManager.myBases || []).filter((base) => {
      const expiresMs = toMs(base.expiresAt);
      return !expiresMs || expiresMs > now;
    }).slice(0, max);
    const chips = active.map((base) => ({
      key: base.id || `${base.cityId}-${base.slotIndex}`,
      cityId: base.cityId,
      label: t(getCityNameKey(base.cityId))
    }));
    while (chips.length < max) {
      chips.push({ key: `empty-${chips.length}`, cityId: null, label: t(BASE_KEYS.SLOT_EMPTY) });
    }
    return chips;
  }, [baseManager.myBases, baseManager.config, t]);

  const focusBaseCity = useCallback((cityId) => {
    setMapPanCityId(cityId);
    const listEl = document.querySelector(`[data-base-city="${cityId}"]`);
    if (listEl) listEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }, []);

  const [modalProps, setModalProps] = useState(null);
  // [NEW] Registration Flow State
  const [showRegModal, setShowRegModal] = useState(false);
  const [regStep, setRegStep] = useState(0); // 0: Type Select, 1: Form
  const [regType, setRegType] = useState('store'); // 'store' | 'my_land'
  // My Land 등록 (+, 모달 내): 슬롯·이름·수정모드
  const [regMyLandSlot, setRegMyLandSlot] = useState(1);
  const [regMyLandName, setRegMyLandName] = useState('');
  const [isRenaming, setIsRenaming] = useState(false);
  // Split state for persistent drafts
  const [forms, setForms] = useState({
    store: { title: '', content: '' }
  });
  // 🎯 [NEW] Image Selection State
  const [selectedFiles, setSelectedFiles] = useState([]);

  // Feature: Radar Interaction
  const [selectedSpotId, setSelectedSpotId] = useState(null);
  const [detailedSpot, setDetailedSpot] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null); // 🎯 [UI] Lightbox State // Modal State
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [isAddingComment, setIsAddingComment] = useState(false); // 🎯 [FIX] 댓글 중복 방지

  // 🎯 [NEW] 수정 모달 상태
  const [showEditModal, setShowEditModal] = useState(false);
  const [editForm, setEditForm] = useState({ title: '', content: '' });

  // 🎯 [FIX] 좋아요 중복 클릭 방지 (Debounce)
  const [processingLikes, setProcessingLikes] = useState(new Set());

  // 🎯 [NEW] 만료일 정보 팝업 상태
  const [showExpiryInfoModal, setShowExpiryInfoModal] = useState(false);
  const [expiryInfoType, setExpiryInfoType] = useState(null); // 'post' or 'store'

  // ✅ Phase 2: 헤더 포인트 확장 상태
  const [showCurrencyModal, setShowCurrencyModal] = useState(false);
  const [showAnnouncementModal, setShowAnnouncementModal] = useState(false); // 🎯 [NEW] Announcement Modal
  const [showReferralModal, setShowReferralModal] = useState(false);

  // 🎯 [NEW] Announcements - 읽지 않은 공지 체크
  const { hasUnread: hasUnreadAnnouncements } = useAnnouncementsFirestore(environment);
  // 🔁 SPOT 포인트는 AppContext에서 이미 실시간 동기화되므로 별도 리스너 불필요



  // 🔴 [REMOVED] 중복 상태 - useSpotLocation Hook에서 관리
  // const [myPos, setMyPos] = useState(null);
  // const [gpsToast, setGpsToast] = useState({ show: false, message: '' });
  // const initialPosRef = useRef(null);
  // const [locationSource, setLocationSource] = useState('wifi');

  const [showRadar, setShowRadar] = useState(true);
  // const [showLocation, setShowLocation] = useState(false); // Privacy Default: Hidden

  // 🎯 [간소화] Pi 로그인 모달 상태
  const [piLoginModal, setPiLoginModal] = useState({ show: false, loading: false, message: '', type: 'info' });

  // 🎯 [ToS] 게스트 ToS 동의 상태 (sessionStorage 변경 감지용)
  const [guestTosAgreed, setGuestTosAgreed] = useState(() =>
    !piUser && sessionStorage.getItem('guest_tos_agreed') === 'true'
  );

  // 🎯 [ToS] 게스트 ToS 동의 시 상태 업데이트 (커스텀 이벤트 리스너)
  useEffect(() => {
    if (piUser) return; // Pi 사용자는 savedAgreements로 처리

    const handleTosAgreed = () => {
      console.log('[SpotGoMain] 🎉 Guest ToS agreed event received');
      setGuestTosAgreed(true);
    };

    window.addEventListener('guest-tos-agreed', handleTosAgreed);
    return () => window.removeEventListener('guest-tos-agreed', handleTosAgreed);
  }, [piUser]);

  // 🎯 [NEW] Deep Link - URL에서 spotId 파라미터 감지하여 자동 열기
  const [pendingSpotId, setPendingSpotId] = useState(null);

  useEffect(() => {
    // Hash router URL에서 query parameter 추출: #/main?spotId=xxx
    const hashParts = window.location.hash.split('?');
    if (hashParts.length > 1) {
      const urlParams = new URLSearchParams(hashParts[1]);
      const spotId = urlParams.get('spotId');
      if (spotId) {
        setPendingSpotId(spotId);
        // URL에서 spotId 제거 (새로고침 시 재호출 방지)
        window.history.replaceState(null, '', `${window.location.pathname}#/main`);
      }
    }
  }, []);

  // 🎯 [Deep Link] spots 로드 여부와 관계없이 spotId가 있으면 처리
  useEffect(() => {
    const handleDeepLink = async () => {
      if (pendingSpotId) {
        // 1. Try Local Find
        let targetSpot = spots.find(s => s.id === pendingSpotId);

        // 2. If locally missing (or spots not loaded yet), Fetch from Server
        if (!targetSpot) {
          try {
            targetSpot = await SpotService.getSpotById(pendingSpotId, environment);
            if (targetSpot && myPos && targetSpot.geo) {
              // 거리 계산 (Local logic copy)
              const d = getDistanceFromLatLonInKm(myPos.lat, myPos.lng, targetSpot.geo.lat, targetSpot.geo.lng) * 1000;
              targetSpot.distance = formatDistance(d);
            }
          } catch (e) {
            console.warn("[Deep Link] Failed to fetch spot:", e);
          }
        }

        if (targetSpot) {
          // 약간의 지연으로 UI 안정 후 열기
          setTimeout(async () => {
            // 🎯 [Fetch Like State]
            let isLiked = false;
            if (piUser) {
              isLiked = await SpotService.checkIsLiked(targetSpot.id, piUser.uid, environment);
            }
            setDetailedSpot({ ...targetSpot, liked: isLiked });
            setShowDetailModal(true);

            // 댓글 유무 확인 후 로드 (서버 부하 감소)
            if ((targetSpot.commentCount || 0) > 0) {
              SpotService.getComments(pendingSpotId, environment)
                .then(data => setComments(data))
                .catch(err => console.error('Comments load error:', err));
            } else {
              setComments([]);
            }
          }, 300);
          setPendingSpotId(null);
        }
      }
    };
    handleDeepLink();
  }, [pendingSpotId, spots, environment, piUser, myPos]);

  // --- Alert Helper ---
  const showAlert = (message) => {
    setModalProps({
      message,
      onConfirm: () => setModalProps(null),
      onCancel: null, // No cancel button for alerts
    });
  };

  // --- Confirm Helper ---
  const showConfirm = (message, onConfirm, onCancel, type = 'info') => {
    setModalProps({
      message,
      onConfirm: async () => {
        setModalProps(null);
        try {
          if (onConfirm) await onConfirm();
        } catch (e) {
          console.error(e);
        }
      },
      onCancel: () => {
        setModalProps(null);
        try {
          if (onCancel) onCancel();
        } catch (e) {
          console.error(e);
        }
      },
      type,
    });
  };

  // 🎯 [Spot Go MVP] Landmark visit system settings (spots 전달 → 화면 내 랜드마크만 조회, DB 읽기 절감)
  const {
    landmarkStatus,
    handleVisit: handleLandmarkVisit,
    handleClaim: handleLandmarkClaim,
    getLandmarkState
  } = useLandmarkManager(piUser, showAlert, t, { spots, myLandCapture });

  // 🐛 [Bugfix 2026-07-09] 광고 방문 중복 클릭 방지 락 (landmarkId 저장, ref는 즉시성/state는 UI 반영용)
  const adVisitLoadingIdRef = useRef(null);
  const [adVisitLoadingId, setAdVisitLoadingId] = useState(null);

  // ✅ Phase 1: 방문 확인 팝업 헬퍼
  const handleLandmarkVisitConfirm = (landmarkId, onConfirmedAction) => {
    const state = getLandmarkState(landmarkId);
    const isEmptyLand = state.isEmpty;

    const message = isEmptyLand
      ? t('landmark_visit_confirm')
      : t('landmark_capture_confirm');

    showConfirm(
      message,
      () => {
        setModalProps(null);
        onConfirmedAction(); // Execute the action
      },
      () => setModalProps(null),
      'warning'
    );
  };

  // 🎯 [Phase 4] 광고 보고 랜드마크 방문 핸들러 (Refactored)
  // 🐛 [Bugfix 2026-07-09] 광고 시청 중 중복 클릭 시 spotGoAction이 중복 호출되어
  // LAND_LIMIT 오류/점유 카운트 오염이 발생하는 문제 수정 (실 로그로 확인된 버그)
  const handleAdLandmarkVisit = useCallback(async (landmarkId) => {
    if (!detailedSpot) return;

    // 🐛 [Bugfix] 이미 광고 시청~방문 처리가 진행 중이면 재진입 차단 (중복 클릭/이벤트 방지)
    if (adVisitLoadingIdRef.current) return;
    adVisitLoadingIdRef.current = landmarkId;
    setAdVisitLoadingId(landmarkId);

    // 🎯 [UX Improvement] 광고 시청 전 보유 한도 체크 (Client-side Pre-check)
    // 불필요한 광고 시청 방지 및 "유령 랜드마크" 디버깅용
    const myLandmarkCount = Object.values(landmarkStatus).filter(l =>
      l.ownerId === piUser?.uid &&
      (!l.expiresAt || l.expiresAt.toDate() > new Date()) // 만료되지 않은 것만 카운트
    ).length;

    if (myLandmarkCount >= 3) {
      showAlert(t('landmark_limit_reached', { current: myLandmarkCount, max: 3 }));
      adVisitLoadingIdRef.current = null;
      setAdVisitLoadingId(null);
      return;
    }

    // 1. Set Heavy Task State (Pause App)
    setHeavyTaskState(true, 'landmark_ad_visit');

    // 2. Call Standard Ad Flow
    watchAdForLandmarkVisit(
      async (_result) => {
        // Success
        setHeavyTaskState(false, 'landmark_ad_visit');

        try {
          // 🎯 [Fix] 광고 시청 완료 -> isAdReward: true 전달 및 방문 처리
          await handleLandmarkVisit(landmarkId, detailedSpot, { isAdReward: true });
        } finally {
          // 🐛 [Bugfix] 방문 처리(성공/실패 무관)까지 끝난 후에만 잠금 해제
          adVisitLoadingIdRef.current = null;
          setAdVisitLoadingId(null);
        }
      },
      (error) => {
        // Error
        setHeavyTaskState(false, 'landmark_ad_visit'); // Ensure state is cleared
        console.warn('[SpotGoMain] Landmark ad failed:', error);
        // Optional: showAlert(error);
        adVisitLoadingIdRef.current = null;
        setAdVisitLoadingId(null);
      }
    );
  }, [detailedSpot, watchAdForLandmarkVisit, handleLandmarkVisit, setHeavyTaskState, landmarkStatus, piUser, showAlert, t]);

  // --- Touch Rotation Logic ---
  const handleTouchStart = (e) => {
    if (e.touches.length === 2) {
      const t1 = e.touches[0];
      const t2 = e.touches[1];
      const angle = Math.atan2(t2.clientY - t1.clientY, t2.clientX - t1.clientX) * (180 / Math.PI);
      setTouchStartAngle(angle - radarRotation);
    }
  };

  const handleTouchMove = (e) => {
    if (e.touches.length === 2 && touchStartAngle !== null) {
      const t1 = e.touches[0];
      const t2 = e.touches[1];
      const angle = Math.atan2(t2.clientY - t1.clientY, t2.clientX - t1.clientX) * (180 / Math.PI);
      setRadarRotation(angle - touchStartAngle);
    }
  };

  const handleTouchEnd = () => {
    setTouchStartAngle(null);
  };

  // 🎯 [Refactor] Modal touch logic moved to SpotDetailModal.js

  // 🎯 [Refactor] Modal state management moved to SpotDetailModal.js


  // \ud83d\udd34 [REMOVED] Permission States - useSpotLocation Hook\uc5d0\uc11c \uad00\ub9ac
  // const [permissionStatus, setPermissionStatus] = useState('prompt');
  // const [permissionModal, setPermissionModal] = useState({ show: false, type: null });


  // 🎯 [NEW] Location Initialization - useSpotLocation Hook 사용
  const hasRunStrategy = useRef(false);

  // 🎯 [ToS] ToS 동의 여부 확인 함수
  const isTosAgreed = () => {
    // 게스트: React 상태 확인 (sessionStorage 대신)
    if (!piUser) {
      return guestTosAgreed;
    }
    // 로그인 유저: savedAgreements 확인
    return savedAgreements?.termsVersion && savedAgreements?.privacyVersion && savedAgreements?.locationVersion;
  };

  useEffect(() => {
    if (hasRunStrategy.current) return;

    // 🎯 [ToS] ToS 동의 전에는 스캔 시작하지 않음
    if (!isTosAgreed()) {
      console.log('[SpotGoMain] ⏸️ Waiting for ToS agreement before scanning...');
      return;
    }

    hasRunStrategy.current = true;
    console.log('[SpotGoMain] 🏁 Starting Initial Scan Strategy');

    runInitialScanStrategy(async (position) => {
      // 🎯 [Fix] Race Condition 해결: 캐시 또는 GPS로 위치를 받으면 즉시 Controller에 전달
      if (position && position.lat && position.lng) {
        setUserLocation(position);
        setIsLocationReady(true);
      }
    });
  }, [runInitialScanStrategy, setUserLocation, setIsLocationReady, piUser, savedAgreements, guestTosAgreed]); // 🎯 [ToS] 게스트/Pi 모두 동의 상태 추적

  // 🎯 [Optimization] Cost Saving Logic
  const [scanCenter, setScanCenter] = useState(null); // Last DB Scan Position
  // const SCAN_THRESHOLD_M = 2000; // Removed -> SPOT_CONSTANTS.SCAN_THRESHOLD_M
  const hasScannedWithGpsRef = useRef(false); // 🎯 [Fix] GPS 정밀 스캔 여부
  const gpsForceRefreshCooldownMs = 30 * 60 * 1000; // 30분 쿨다운

  // 🎯 [REMOVED] myPos Update Handler - Bridge useEffect + Controller handles this
  // 이전에는 myPos 변경 시 여기서 handleScan을 호출했지만,
  // Bridge useEffect(Line 118-124)가 Controller에 위치를 전달하고,
  // Controller의 useEffect가 fetchSpots를 호출하므로 중복됨.
  // 
  // GPS Lock 시 강제 재스캔 로직만 유지:
  useEffect(() => {
    if (!myPos) return;

    // Initial Center 설정 (첫 로드 시)
    if (!scanCenter) {
      setScanCenter(myPos);
      if (locationSource === 'gps') {
        hasScannedWithGpsRef.current = true;
      }
      return; // Bridge + Controller가 첫 로드 처리
    }

    // 🎯 GPS Lock 획득 시 강제 재스캔 (캐시 → GPS 전환 시)
    if (locationSource === 'gps' && !hasScannedWithGpsRef.current) {
      const cooldownKey = `spot_gps_force_refresh_${piUser?.uid || 'guest'}_${environment || 'production'}`;
      const lastAt = Number(sessionStorage.getItem(cooldownKey) || 0);
      const now = Date.now();
      if (!lastAt || (now - lastAt) > gpsForceRefreshCooldownMs) {
        console.log('[SpotGoMain] 🚀 GPS Lock Acquired! Forcing Accurate Re-Scan...');
        setScanCenter(myPos);
        hasScannedWithGpsRef.current = true;
        sessionStorage.setItem(cooldownKey, String(now));
        refreshSpots(); // Controller를 통해 재스캔
      } else {
        console.log('[SpotGoMain] ⏭️ GPS Lock Re-Scan skipped (cooldown)');
        hasScannedWithGpsRef.current = true;
      }
    }
  }, [myPos, locationSource, refreshSpots, scanCenter, piUser?.uid, environment]);


  // 🔴 [REMOVED] 기존 위치 초기화 로직 (Line 358-475) - useSpotLocation Hook으로 완전 교체됨

  // Compute Top 5 from Local Spots (Updates when allSpots or radius changes)
  useEffect(() => {
    if (allSpots.length === 0) {
      setTopStores([]);
      return;
    }

    // 🎯 [Fix] Filter by radius first, then sort for TOP 5
    // - 거리(km) 변경 시 TOP 5 업데이트
    // - 타입 필터(ALL/STORE/POST) 변경 시에는 유지
    const spotsInRadius = allSpots.filter(s => (s.distanceValue || 0) <= radius);

    const localStores = spotsInRadius.filter(s => s.type === 'store').sort((a, b) => (b.verificationCount || 0) - (a.verificationCount || 0)).slice(0, 5);

    setTopStores(localStores);
  }, [allSpots, radius]); // 🎯 [Fix] radius 추가로 거리 변경 시 TOP 5 업데이트



  // Helper: Haversine
  const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
    var R = 6371;
    var dLat = deg2rad(lat2 - lat1);
    var dLon = deg2rad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
  }
  const deg2rad = (deg) => deg * (Math.PI / 180);
  const formatDistance = (meters) => meters < 1000 ? `${Math.round(meters)}m` : `${(meters / 1000).toFixed(1)}km`;

  // 🔴 [REMOVED] Helper Functions - useSpotLocation Hook에서 관리
  // getCurrentLocation(), getHighAccuracyLocation(), getDistanceBetweenPositions()

  // 🔴 [REMOVED] Legacy handleScan (Moved to Controller)

  // 1. Payment: Verify (0.1 Pi)
  const handleVerify = (spot) => {
    if (!processPiPayment) return showAlert(t(SPOT_MESSAGES.PAYMENT_UNAVAILABLE));

    showConfirm(
      t(SPOT_MESSAGES.VERIFY_CONFIRM, { title: spot.title, cost: "0.1 Pi" }),
      async () => {
        setModalProps(null);
        try {
          // 🎯 [Refactor] Use SpotService for safety & environment isolation
          const result = await SpotService.verifyStore(spot.id, piUser, processPiPayment, environment);

          // 🎯 Local State Update
          const newVerificationCount = (detailedSpot?.verificationCount || spot.verificationCount || 0) + 1;

          if (detailedSpot && detailedSpot.id === spot.id) {
            setDetailedSpot(prev => ({
              ...prev,
              verificationCount: newVerificationCount
            }));
          }

          // 🎯 [List Sync] Update List Item
          // 🎯 [Fix] verifyStore는 boolean을 반환하므로 직접 체크
          if (result === true) {
            showAlert(t(SPOT_MESSAGES.VERIFICATION_SUCCESS));
            updateSpot(spot.id, { isVerified: true });
          } else {
            // result가 false인 경우는 없지만, 안전성을 위해 유지
            showAlert(t(SPOT_MESSAGES.REG_FAIL, { message: 'Verification failed' }));
          }
        } catch (e) {
          console.error(e);
          if (e.message === "ALREADY_VERIFIED") {
            showAlert(t(SPOT_MESSAGES.ALREADY_VERIFIED));
          } else {
            showAlert(t(SPOT_MESSAGES.REG_FAIL, { message: e.message }));
          }
        }
      },
      () => setModalProps(null),
      'verify'
    );
  };

  // 🎯 Back Button Logic for Modal
  // 🎯 Back Button Logic for Modals (Register & Detail)
  useEffect(() => {
    const handlePopState = () => {
      // If back button is pressed, close any open modal
      if (showRegModal) {
        setShowRegModal(false);
      }
      if (detailedSpot) {
        setDetailedSpot(null);
      }
      // Clean up session flag? Maybe not needed strictly if we trust state
    };

    const isModalOpen = showRegModal || !!detailedSpot;

    if (isModalOpen) {
      // Only push state if not already there (simple check)
      // Note: This simple logic might push multiple states if multiple modals open sequentially without closing?
      // But here we switch modes. Let's just push state when a modal Opens.
      // However, useEffect runs on render. Using a ref to track pushed state is better.
      // For simplicity, let's rely on the browser history stack.
      // Every time isModalOpen becomes true, we push.

      // We need to differentiate "mounting" vs "updates".
      // But since modals are bools:
      window.history.pushState({ modal: 'open' }, '');
      window.addEventListener('popstate', handlePopState);
    } else {
      window.removeEventListener('popstate', handlePopState);
    }

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [showRegModal, detailedSpot]);

  // 2. Register Flow Entry


  // 3. Final Submit Handler with Auto-Geolocation
  // 🎯 [수정] DonationModal과 동일한 결제 패턴 적용 - 직접 window.Pi.createPayment 호출
  // 🎯 [Safety] Duplicate Submission Lock
  // 🎯 [Safety] Duplicate Submission Lock
  const [isSubmitting, setIsSubmitting] = useState(false);

  // 🎯 [NEW] File Selection Handler
  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    // Policy Check (Max count)
    const maxCount = regType === 'store' ? 5 : 3;
    if ((selectedFiles.length + files.length) > maxCount) {
      return showAlert(t(SPOT_MESSAGES.PHOTO_LIMIT_EXCEEDED, { type: t(SPOT_MESSAGES.TYPE_STORE), count: maxCount }));
    }

    // Update state
    setSelectedFiles(prev => [...prev, ...files]);
  };

  // 3. Final Submit Handler with Auto-Geolocation
  const handleRegSubmit = async () => {
    if (isSubmitting) return; // 🔒 Prevent Double Click

    // 🎯 [FIX] 게스트 사용자 조기 체크 - 친화적 메시지
    if (!piUser || !piUser.uid) {
      return showAlert(t(SPOT_MESSAGES.GUEST_RESTRICTION));
    }

    const currentForm = forms[regType];
    if (!currentForm?.title.trim() || !currentForm?.content.trim()) {
      return showAlert(t(SPOT_MESSAGES.INPUT_REQUIRED));
    }

    if (!myPos) return showAlert(t(SPOT_MESSAGES.LOCATION_ERROR));

    // 🎯 [NEW 2026-02-08] 매장 등록 티켓 잔액 확인 (10개)
    if (regType === 'store' && ticketCount < 10) {
      return showAlert(t('spot_insufficient_tickets', { required: 10, count: ticketCount }));
    }
    // Prevent double submission
    if (loading || isUploadingImages) return;

    setIsSubmitting(true);

    try {
      // 0. Cooldown Check (Duplicate Prevention)
      // 🎯 [Fix] Simplified query to only use userId + createdAt index (already exists)
      // Type filtering is done client-side to avoid needing a new composite index
      if (piUser?.uid) {
        const spotsCol = getCollectionPath("spots", environment);
        const recentPostsQuery = query(
          collection(db, spotsCol),
          where("userId", "==", piUser.uid),
          orderBy("createdAt", "desc"),
          limit(5)
        );
        const recentSnapshot = await getDocs(recentPostsQuery);
        // Filter by type client-side
        const matchingPost = recentSnapshot.docs.find(doc => doc.data().type === regType);
        if (matchingPost) {
          const lastPost = matchingPost.data();
          const lastTime = lastPost.createdAt?.toDate ? lastPost.createdAt.toDate() : new Date(lastPost.createdAt);
          const diff = (Date.now() - lastTime.getTime()) / 1000;
          if (diff < 60) { // 60 seconds cooldown
            return showAlert(t(SPOT_MESSAGES.COOLDOWN_WAIT));
          }
        }
      }

      // Auto-Geolocation Check
      let finalPos = myPos;
      // ... (existing geolocation logic if needed, but myPos is usually ready)

      // 🎯 [NEW] uploadImages call
      let uploadedPhotoUrls = [];
      let uploadedThumbnails = []; // 🎯 [NEW] 썸네일 배열
      if (selectedFiles.length > 0) {
        try {
          // regType is 'store' or 'my_land'
          // uploadImages(files, type, user)
          if (!piUser?.uid) throw new Error(t(SPOT_MESSAGES.LOGIN_REQUIRED));
          const uploadResults = await uploadImages(selectedFiles, regType, piUser, environment);

          uploadedPhotoUrls = uploadResults.map(r => r.url); // Main URLs
          uploadedThumbnails = uploadResults.map(r => r.thumbnailUrl).filter(Boolean); // Thumbnail URLs
        } catch (err) {
          console.error(err);
          throw new Error(t(SPOT_MESSAGES.REG_FAIL, { message: err.message }));
        }
      }

      // 🎯 [POST 숨김] 일반 등록은 STORE만 제공
      await SpotService.registerSpot(
        {
          title: currentForm.title.trim(),
          content: currentForm.content.trim(),
          type: regType,
          geo: { lat: finalPos.lat, lng: finalPos.lng },
          geohash: LocationService.getGeohash(finalPos.lat, finalPos.lng),
          photos: uploadedPhotoUrls,
          thumbnails: uploadedThumbnails // 🎯 [NEW] 썸네일 저장
        },
        piUser,
        environment,
        async () => {
          // 🎯 [NEW] STORE 등록 시 티켓 10개 차감
          await spendPpPoints(0, 'store_registration', -10);
        }
      );

      showAlert(t(SPOT_MESSAGES.REG_SUCCESS, { type: t(SPOT_MESSAGES.TYPE_STORE) }));
      setShowRegModal(false);
      setForms(prev => ({ ...prev, [regType]: { title: '', content: '' } }));
      setSelectedFiles([]); // Reset files
      clearSpotsCache(); // 🎯 [FIX] 등록 성공 시 캐시 무효화
      refreshSpots(); // Refresh list

    } catch (e) {
      console.error(e);
      if (e.message === "PAYMENT_CANCELLED") {
        showAlert(t(SPOT_MESSAGES.PAYMENT_CANCELLED));
      } else if (e.message === "WAIT_COOLDOWN") {
        showAlert(t(SPOT_MESSAGES.COOLDOWN_WAIT));
      } else if (e.message === "INSUFFICIENT_FUNDS") {
        showAlert(t(SPOT_MESSAGES.INSUFFICIENT_FUNDS));
      } else if (e.message === "INSUFFICIENT_TICKETS") {
        showAlert(t(SPOT_MESSAGES.INSUFFICIENT_TICKETS));
      } else {
        showAlert(t(SPOT_MESSAGES.REG_FAIL, { message: e.message }));
      }
    } finally {
      setIsSubmitting(false); // 🔓 Release Lock (Always)
    }
  };

  // 🎯 [Refactor] Controller handles filtering & sorting now
  // 🎯 [NEW] Apply My Spot Filter (in addition to controller filtering)
  const filteredSpots = (() => {
    const mergeLandmarksWithMyLand = (baseSpots) => {
      // 게스트/초기화 단계에서는 My Land 문서를 생성하지 않고 기본 랜드마크만 반환
      if (!piUser?.uid) {
        return (baseSpots || [])
          .filter(s => s.type === 'landmark')
          .sort((a, b) => (a.distanceValue ?? Number.MAX_SAFE_INTEGER) - (b.distanceValue ?? Number.MAX_SAFE_INTEGER));
      }

      const toDistanceMeters = (lat1, lng1, lat2, lng2) => {
        const toRad = (v) => (v * Math.PI) / 180;
        const R = 6371000;
        const dLat = toRad(lat2 - lat1);
        const dLng = toRad(lng2 - lng1);
        const a =
          Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
          Math.sin(dLng / 2) * Math.sin(dLng / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
      };
      const formatDist = (meters) => (meters < 1000 ? `${Math.round(meters)}m` : `${(meters / 1000).toFixed(1)}km`);
      const getRemainingParts = (expiresAtValue) => {
        const expiresAtMs = expiresAtValue?.toDate
          ? expiresAtValue.toDate().getTime()
          : (typeof expiresAtValue === 'number' ? expiresAtValue : 0);
        if (!expiresAtMs || expiresAtMs <= 0) return null;
        const diffMs = Math.max(0, expiresAtMs - Date.now());
        const totalHours = Math.ceil(diffMs / (1000 * 60 * 60));
        const days = Math.floor(totalHours / 24);
        const hours = totalHours % 24;
        return { days, hours };
      };

      const baseLandmarks = (baseSpots || []).filter(s => s.type === 'landmark');

      // my_land_status 문서도 LAND 리스트에 합쳐서 즉시 노출
      const now = Date.now();
      // 🎯 [UX Fix] Include ALL active slots, not just captured ones
      const getSlotMillis = (ts) => {
        if (!ts) return 0;
        if (typeof ts.toMillis === 'function') return ts.toMillis();
        if (ts.seconds != null) return ts.seconds * 1000;
        if (typeof ts === 'number') return ts;
        return 0;
      };
      const extraMyLand = [1, 2, 3].filter(s => {
        const slotState = s >= 2 ? (myLandSlots || {})[`slot${s}`] : { permanent: true };
        const active = s < 2 || (!!slotState && (slotState.permanent === true || getSlotMillis(slotState.expiresAt) > now));
        return active;
      }).map(s => {
        const docId = `myland_${piUser.uid}_${s}`;
        const status = landmarkStatus[docId];
        const reg = (myLandRegistrations || {})[`slot${s}`];
        // 🚨 [Bug Fix] Backend stores registrations as { lat, lng, name } (flat), NOT { geo: { lat, lng } }
        const parseCoord = (v) => {
          if (typeof v === 'number' && Number.isFinite(v)) return v;
          if (v != null && v !== '') {
            const n = Number(v);
            if (Number.isFinite(n)) return n;
          }
          return null;
        };
        const lat = parseCoord(reg?.lat) ?? parseCoord(status?.lat);
        const lng = parseCoord(reg?.lng) ?? parseCoord(status?.lng);
        const hasCoords = lat != null && lng != null;
        const distanceValue = (myPos && hasCoords)
          ? toDistanceMeters(myPos.lat, myPos.lng, lat, lng)
          : null;
          
        return {
          id: docId,
          type: 'landmark',
          subType: 'my_land',
          slotNum: s,
          name: reg?.name || status?.landmarkName || t('my_land_title', { n: s }),
          title: reg?.name || status?.landmarkName || t('my_land_title', { n: s }),
          content: (() => {
            const slotState = (myLandSlots || {})[`slot${s}`];
            const remaining = getRemainingParts(status?.expiresAt || (s >= 2 ? slotState?.expiresAt : null));
            if (!remaining) return reg ? t('my_land_desc') : t('my_land_unregistered_desc');
            return t('my_land_desc_with_remaining', { days: remaining.days, hours: remaining.hours });
          })(),
          geo: hasCoords ? { lat, lng } : null,
          distanceValue,
          distance: distanceValue != null ? formatDist(distanceValue) : '-',
          isRegistered: !!reg,
          isCaptured: !!status && status.ownerId === piUser.uid
        };
      });

      const merged = new Map();
      [...baseLandmarks, ...extraMyLand].forEach((item) => merged.set(item.id, item));
      return Array.from(merged.values()).sort((a, b) => (a.distanceValue ?? Number.MAX_SAFE_INTEGER) - (b.distanceValue ?? Number.MAX_SAFE_INTEGER));
    };

    // 필터 해제 상태에서도 LAND/ALL 탭은 기존 랜드마크 + My Land를 함께 노출
    if (!mySpotFilter || !piUser) {
      if (filterMode === 'landmark') {
        return mergeLandmarksWithMyLand(spots);
      }
      if (filterMode === 'all') {
        // ALL 탭: POST 폐기 준비로 footprint는 사용자 노출에서 제외
        const landmarkMerged = mergeLandmarksWithMyLand(spots);
        const nonLandmarkSpots = spots.filter(s => s.type !== 'landmark' && s.type !== 'footprint');
        const merged = new Map();
        [...landmarkMerged, ...nonLandmarkSpots].forEach(item => merged.set(item.id, item));
        return Array.from(merged.values()).sort(
          (a, b) => (a.distanceValue ?? Number.MAX_SAFE_INTEGER) - (b.distanceValue ?? Number.MAX_SAFE_INTEGER)
        );
      }
      return spots;
    }

    switch (mySpotFilter) {
      case 'my_posts':
        return [];
      case 'my_store':
        // 내가 등록한 매장 (store)
        return spots.filter(s =>
          s.type === 'store' &&
          (s.userId === piUser.uid || s.userName === piUser.username)
        );
      case 'my_comments':
        return [];
      case 'my_land':
        // 내 점유지 (내가 점유한 일반 랜드마크 + My Land)
        return mergeLandmarksWithMyLand(spots).filter(s => {
          if (s.type !== 'landmark') return false;
          const status = landmarkStatus[s.id];
          if (!status) return false;
          return status.ownerId === piUser?.uid;
        });
      default:
        return spots;
    }
  })();



  // Calculations for Radar
  const calculateRadarPosition = (spotLat, spotLng) => {
    if (!myPos) return { top: '50%', left: '50%' };

    // Simple relative calculation for visual represenation (not perfect geodesy but enough for UI)
    const latDiff = (spotLat - myPos.lat) * 111000; // approx meters
    const lngDiff = (spotLng - myPos.lng) * (111000 * Math.cos(myPos.lat * Math.PI / 180));

    // Max radius is current distanceRadius
    const maxDist = distanceRadius;
    const dist = Math.sqrt(latDiff * latDiff + lngDiff * lngDiff);

    // Scale to 0-45% (keep inside 50% radius circle with padding)
    const scale = Math.min(dist / maxDist, 1) * 45;
    // Fix: atan2(x, y) for North Up (0 deg)
    const angle = Math.atan2(lngDiff, latDiff);

    // Convert to top/left %
    // North (angle 0) -> cos(0)=1 -> top 50 - scale
    return {
      top: `${50 - (Math.cos(angle) * scale)}%`,
      left: `${50 + (Math.sin(angle) * scale)}%`
    };
  };

  // Discrete Steps for Chips
  // STEPS moved to SPOT_CONSTANTS.RADAR_STEPS

  // 🎯 [NEW] Premium Radius Payment Handler
  const handlePremiumConfirm = async () => {
    setShowPremiumModal(false);

    try {
      // Spend STAR points
      const cost = SPOT_CONSTANTS.PREMIUM_RADIUS.COST;
      const result = await spendPpPoints(cost, `spend_radius_${cost}`); // 🎯 [Fix] Add item name for history

      if (!result) {
        return showAlert(t('spot_not_enough_star'));
      }

      // Unlock premium radius
      unlockPremiumRadius();

      // Apply 50km radius
      handleScan(SPOT_CONSTANTS.PREMIUM_RADIUS.VALUE);

      // Success
      showAlert(t('premium_unlock_success'));
    } catch (err) {
      console.error('[Premium] Payment error:', err);
      showAlert(t('spot_purchase_fail') + err.message);
    }
  };

  const handleChipClick = (dist) => {
    // 🎯 [Premium] 50km Lock Check
    if (dist === SPOT_CONSTANTS.PREMIUM_RADIUS.VALUE) {
      if (!isPremiumUnlocked) {
        setShowPremiumModal(true);
        return;
      }
    }

    if (distanceRadius !== dist) {
      handleScan(dist); // handleScan now handles setRadius internally
    }
  };

  // Navigate to map and highlight spot (shows map in radar area, not fullscreen)
  const handleGoToMap = (spot) => {
    setSelectedMapSpotId(spot.id);
    rememberMapChoice(true);
    // 🎯 [UX] 확장 상태 유지 (기존: 축소)
    // setIsMapExpanded(false); // 삭제됨

    // 🎯 [NEW] 피드 카드 펄스 효과 (일관성 유지)
    // 이미 보고 있는 카드지만, '지도에서 보기' 동작에 대한 피드백으로 강조
    setTimeout(() => {
      // 기존 효과 제거
      document.querySelectorAll('.highlight-pulse').forEach(el => {
        el.classList.remove('highlight-pulse');
      });

      const feedCard = document.getElementById(`spot-card-${spot.id}`);
      if (feedCard) {
        feedCard.classList.add('highlight-pulse');
        setTimeout(() => {
          feedCard.classList.remove('highlight-pulse');
        }, 2000);
      }
    }, 100);
  };

  // Infinite Scroll Observer
  // Infinite Scroll Observer (Disabled - Unused)
  /*
  useEffect(() => {
    if (!loadTrigger) return;
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && visibleCount < filteredSpots.length) {
        setVisibleCount(prev => prev + 10);
      }
    }, { threshold: 0, rootMargin: '500px' }); // Aggressive pre-loading
    observer.observe(loadTrigger);
    return () => observer.disconnect();
  }, [loadTrigger, visibleCount, filteredSpots.length]);
  */

  // --- Detail Modal Functions ---
  const handleOpenDetail = async (spot) => {
    setSelectedSpotId(spot.id); // Highlight Radar logic

    // Also highlight on Map if map is visible or just to be ready
    setSelectedMapSpotId(spot.id);
    // Auto-clear map highlight after 3 seconds
    // Auto-clear map highlight deleted
    // setTimeout(() => setSelectedMapSpotId(null), 3000);

    // Landmark: Allow inline interaction (Spot Go MVP)
    // 🎯 [Policy] Landmark only provides location info (Save DB cost & Disable social features)


    // Calculate distance if missing (e.g. from Sidebar)
    let finalSpot = spot;
    if (!spot.distance && myPos && spot.geo) {
      const d = getDistanceFromLatLonInKm(myPos.lat, myPos.lng, spot.geo.lat, spot.geo.lng) * 1000;
      finalSpot = { ...spot, distance: formatDistance(d) };
    }

    // 🎯 [Fetch Like State]
    let isLiked = false;
    if (piUser) {
      isLiked = await SpotService.checkIsLiked(spot.id, piUser.uid, environment);
    }

    setDetailedSpot({ ...finalSpot, liked: isLiked });

    // Fetch Comments
    const commentsData = await SpotService.getComments(spot.id, environment);
    setComments(commentsData);
  };

  // --- Logic Fix: SpotService Integration ---
  const handleAddComment = async () => {
    if (!detailedSpot) return;
    if (!newComment.trim()) {
      return showAlert(t(SPOT_MESSAGES.EDIT_COMMENT_EMPTY));
    }
    if (isAddingComment) return; // 🎯 [FIX] 중복 클릭 방지

    // 🎯 [NEW] 댓글 도배방지 (1분에 1회)
    const COMMENT_COOLDOWN_MS = 60 * 1000; // 1분
    const lastCommentTime = localStorage.getItem('lastCommentTime');
    if (lastCommentTime) {
      const elapsed = Date.now() - parseInt(lastCommentTime, 10);
      if (elapsed < COMMENT_COOLDOWN_MS) {
        const remainingSec = Math.ceil((COMMENT_COOLDOWN_MS - elapsed) / 1000);
        return showAlert(t(SPOT_MESSAGES.COMMENT_COOLDOWN || 'spot_comment_cooldown', { seconds: remainingSec }));
      }
    }

    setIsAddingComment(true); // 🎯 [FIX] 로딩 시작
    try {
      if (!piUser?.uid) throw new Error(t(SPOT_MESSAGES.LOGIN_REQUIRED));

      await SpotService.addComment(detailedSpot.id, piUser.uid, piUser.username, newComment, environment);

      // 🎯 [NEW] 댓글 성공 시 시간 저장
      localStorage.setItem('lastCommentTime', Date.now().toString());

      // Optimistic UI
      const newCommentObj = {
        id: Date.now().toString(),
        text: newComment,
        userName: piUser?.username || t('spot_me'),
        createdAt: new Date()
      };
      setComments([newCommentObj, ...comments]);
      setNewComment("");

      // Update local spot stats
      setDetailedSpot(prev => ({
        ...prev,
        commentCount: (prev.commentCount || 0) + 1
      }));

      showAlert(t(SPOT_MESSAGES.COMMENT_ADDED)); // 🎯 [FIX] 성공 피드백
      refreshSpots(); // 🎯 [Fix] 목록 새로고침 (My Comments 필터 즉시 반영)

    } catch (e) {
      console.error("Comment Error:", e);
      showAlert(e.message);
    } finally {
      setIsAddingComment(false); // 🎯 [FIX] 로딩 종료
    }
  }

  // 🎯 [NEW] 댓글 삭제 핸들러
  const handleDeleteComment = async (commentId) => {
    if (!detailedSpot || !piUser) return;

    setModalProps({
      message: t(SPOT_MESSAGES.DELETE_COMMENT_CONFIRM),
      onConfirm: async () => {
        setModalProps(null);
        try {
          await SpotService.deleteComment(detailedSpot.id, commentId, piUser.uid, environment);

          // Optimistic UI
          setComments(prev => prev.filter(c => c.id !== commentId));
          setDetailedSpot(prev => ({
            ...prev,
            commentCount: Math.max((prev.commentCount || 0) - 1, 0)
          }));
          showAlert(t(SPOT_MESSAGES.DELETE_COMMENT_SUCCESS));
        } catch (e) {
          console.error("Delete Comment Error:", e);
          showAlert(e.message);
        }
      },
      onCancel: () => setModalProps(null)
    });
  };

  // 🎯 [NEW] 댓글 수정 핸들러
  const [editingCommentId, setEditingCommentId] = useState(null);
  const [editingCommentText, setEditingCommentText] = useState("");

  const handleStartEditComment = (comment) => {
    setEditingCommentId(comment.id);
    setEditingCommentText(comment.text);
  };

  const handleSaveEditComment = async () => {
    if (!detailedSpot || !piUser || !editingCommentId) return;
    if (!editingCommentText.trim()) {
      showAlert(t(SPOT_MESSAGES.EDIT_COMMENT_EMPTY));
      return;
    }

    try {
      await SpotService.editComment(detailedSpot.id, editingCommentId, piUser.uid, editingCommentText, environment);

      // Optimistic UI
      setComments(prev => prev.map(c =>
        c.id === editingCommentId ? { ...c, text: editingCommentText.trim() } : c
      ));
      setEditingCommentId(null);
      setEditingCommentText("");
      showAlert(t(SPOT_MESSAGES.EDIT_COMMENT_SUCCESS));
    } catch (e) {
      console.error("Edit Comment Error:", e);
      showAlert(e.message);
    }
  };

  const handleCancelEditComment = () => {
    setEditingCommentId(null);
    setEditingCommentText("");
  };

  // 🎯 [NEW] 지도 마커 클릭 핸들러 - 피드로 이동 + 보라색 강조
  // 🎯 [NEW] 지도 마커 클릭 핸들러 - 피드로 이동 + 보라색 강조
  const handleMapMarkerClick = (spot) => {
    // 1. 스팟 선택 (마커 적색 강조) - 🎯 [FIX] Map State 동기화
    setSelectedSpotId(spot.id);
    setSelectedMapSpotId(spot.id); // 🎯 지도 마커 선택 상태 업데이트 (중요)

    // 2. 지도 닫고 피드로 전환
    // 2. 지도 닫고 피드로 전환 -> 🎯 [UX] 확장 상태 유지
    // setIsMapExpanded(false); // 삭제됨

    // 3. 잠시 대기 후 피드 카드로 스크롤 + 보라색 펄스 효과
    setTimeout(() => {
      // 🎯 [FIX] 기존 강조 효과 모두 제거 (중복 방지)
      document.querySelectorAll('.highlight-pulse').forEach(el => {
        el.classList.remove('highlight-pulse');
      });

      const feedCard = document.getElementById(`spot-card-${spot.id}`);
      if (feedCard) {
        // 부드러운 스크롤
        feedCard.scrollIntoView({ behavior: 'smooth', block: 'center' });

        // 보라색 펄스 효과 추가
        feedCard.classList.add('highlight-pulse');

        // 2초 후 효과 제거
        setTimeout(() => {
          feedCard.classList.remove('highlight-pulse');
        }, 2000);
      }
    }, 300); // 지도 닫히는 애니메이션 대기
  };

  const handleDeleteSpot = async () => {
    if (!detailedSpot || !piUser) return;

    setModalProps({
      message: t(SPOT_MESSAGES.DELETE_SPOT_CONFIRM),
      onConfirm: async () => {
        setModalProps(null);
        try {
          // 🎯 [UX] 팝업 대신 LoadingOverlay 사용 (확인 버튼 없음)
          setIsSubmitting(true);
          await SpotService.deleteSpot(detailedSpot.id, piUser.uid, piUser.username, environment);

          setIsSubmitting(false); // 로딩 종료
          showAlert(t(SPOT_MESSAGES.DELETE_SPOT_SUCCESS));
          setDetailedSpot(null);
          handleScan();
        } catch (e) {
          setIsSubmitting(false);
          console.error("Delete Error:", e);
          showAlert(`삭제 실패: ${e.message}`);
        }
      },
      onCancel: () => setModalProps(null)
    });
  };

  // 🎯 [NEW] 수정 기능 시작
  const handleEditSpot = () => {
    if (!detailedSpot || !piUser) {
      showAlert(t(SPOT_MESSAGES.LOGIN_REQUIRED));
      return;
    }
    if (detailedSpot.userId !== piUser.uid && detailedSpot.userName !== piUser.username) {
      showAlert(t(SPOT_MESSAGES.PERMISSION_DENIED));
      return;
    }

    // 현재 내용으로 폼 초기화 (이미지 병합)
    const existingImgs = (detailedSpot.photos || []).map((url, idx) => ({
      url,
      thumbnailUrl: detailedSpot.thumbnails?.[idx] || null
    }));

    setEditForm({
      title: detailedSpot.title || '',
      content: detailedSpot.content || '',
      existingImages: existingImgs,
      newFiles: [] // 🎯 새로 추가할 파일들
    });
    setShowEditModal(true);
  };

  // 🎯 [NEW] 수정 저장
  const handleSaveEdit = async () => {
    if (!detailedSpot || !editForm.title.trim() || !editForm.content.trim()) {
      showAlert(t(SPOT_MESSAGES.INPUT_REQUIRED));
      return;
    }

    try {
      setIsSubmitting(true); // 🎯 [UX] 팝업 대신 LoadingOverlay 사용
      // 1. Upload New Files
      let addedImages = [];
      if (editForm.newFiles && editForm.newFiles.length > 0) {
        try {
          // uploadImages returns [{ url, thumbnailUrl }]
          addedImages = await uploadImages(editForm.newFiles, detailedSpot.type, piUser, environment);
        } catch (err) {
          throw new Error(`이미지 업로드 실패: ${err.message}`);
        }
      }

      // 2. Merge Images (Existing + Added)
      const finalImages = [...(editForm.existingImages || []), ...addedImages];
      const finalPhotos = finalImages.map(img => img.url);
      const finalThumbnails = finalImages.map(img => img.thumbnailUrl).filter(Boolean);

      // 3. Update Firestore
      await SpotService.editSpot(detailedSpot.id, piUser.uid, piUser.username, {
        title: editForm.title.trim(),
        content: editForm.content.trim(),
        photos: finalPhotos,
        thumbnails: finalThumbnails
      }, environment);

      // UI 즉시 업데이트
      const updatedData = {
        ...detailedSpot,
        title: editForm.title.trim(),
        content: editForm.content.trim(),
        photos: finalPhotos,
        thumbnails: finalThumbnails
      };

      setDetailedSpot(updatedData);

      // 🎯 [List Sync] Update List Item
      updateSpot(detailedSpot.id, {
        title: editForm.title.trim(),
        content: editForm.content.trim(),
        photos: finalPhotos,
        thumbnails: finalThumbnails
      });

      clearSpotsCache(); // 🎯 [FIX] 수정 성공 시 캐시 무효화
      showAlert(t(SPOT_MESSAGES.EDIT_SUCCESS));
      setShowEditModal(false);

      // 목록 새로고침 (불필요)
      // handleScan();
    } catch (e) {
      console.error("Edit Error:", e);
      showAlert(`수정 실패: ${e.message}`);
    } finally {
      setIsSubmitting(false); // 🎯 [UX] 로딩 종료
    }
  };

  // 🎯 [FIX] Like with Subcollection (Use SpotService)
  const handleLike = async (spotId) => {
    if (!detailedSpot || detailedSpot.id !== spotId) return;
    if (!piUser) return showAlert(t(SPOT_MESSAGES.LOGIN_REQUIRED));

    // Optimistic UI Update
    const isLiked = detailedSpot.liked;
    const newLikedState = !isLiked;
    const newCount = (detailedSpot.likeCount || 0) + (newLikedState ? 1 : -1);

    setDetailedSpot(prev => ({
      ...prev,
      liked: newLikedState,
      likeCount: newCount
    }));

    try {
      await SpotService.toggleLike(spotId, piUser.uid, environment);

      // 🎯 [List Sync] Update List Item
      updateSpot(spotId, {
        liked: newLikedState,
        likeCount: newCount
      });


      showAlert(newLikedState ? t(SPOT_MESSAGES.LIKE_SUCCESS) : t(SPOT_MESSAGES.LIKE_CANCEL)); // Feedback
    } catch (e) {
      // 🎯 [Direct DB] No revert needed for typical network errors as we want to keep it snappy.
      // If it fails, it fails silently or on next refresh.
      // But if we want to be strict:
      console.error("Like Failed:", e);
      // setDetailedSpot(prev => ... revert ...); // Disabled for "Always Instant" feel
    }
  };

  // 🎯 [FIX] 피드에서 직접 좋아요 처리 (detailedSpot 없이)
  // 🎯 [FIX] 피드에서 직접 좋아요 처리 (detailedSpot 없이)
  const handleLikeFeed = async (spot) => {
    if (!piUser) return showAlert(t(SPOT_MESSAGES.LOGIN_REQUIRED));

    // 🎯 [Safety] 좋아요 카운트가 undefined일 경우 방어 로직 -> 0으로 취급
    // 🎯 [Lock] 중복 클릭 방지
    if (processingLikes.has(spot.id)) return;

    // Optimistic UI Update
    const isLiked = spot.liked;
    const newLikedState = !isLiked;
    // 🎯 [Logic Fix] String type protection
    const currentCount = typeof spot.likeCount === 'number' ? spot.likeCount : parseInt(spot.likeCount || 0, 10);
    const newCount = Math.max(0, currentCount + (newLikedState ? 1 : -1));

    // Lock & Update
    setProcessingLikes(prev => new Set(prev).add(spot.id));

    // 피드 리스트 즉시 업데이트
    updateSpot(spot.id, {
      liked: newLikedState,
      likeCount: newCount
    });

    try {
      await SpotService.toggleLike(spot.id, piUser.uid, environment);
      showAlert(newLikedState ? t(SPOT_MESSAGES.LIKE_SUCCESS) : t(SPOT_MESSAGES.LIKE_CANCEL)); // Feedback
    } catch (e) {
      console.error("Like Failed:", e);
      // Revert if failed
      updateSpot(spot.id, {
        liked: isLiked,
        likeCount: currentCount
      });
      showAlert(t(SPOT_MESSAGES.LIKE_ERROR));
    } finally {
      // 🔓 Unlock
      setProcessingLikes(prev => {
        const next = new Set(prev);
        next.delete(spot.id);
        return next;
      });
    }
  };

  // 🎯 [UX 개선] 초기 권한/위치 확인 중일 때는 백그라운드에서 처리
  // '사용자 정보 확인 중...' 화면을 제거하고 바로 메인으로 진입
  // (초기 위치가 없어도 SpotController가 자동으로 위치를 가져옴)

  return (
    <Container $isTestnet={isTestnet}>
      {/* 🎯 [Fix] Pi 로그인 모달 - 표준 컴포넌트 사용으로 정렬 문제 해결 */}
      {piLoginModal.show && (
        <ModalOverlay onClick={() => !piLoginModal.loading && setPiLoginModal({ show: false, loading: false, message: '', type: 'info' })}>
          <ModalContent onClick={e => e.stopPropagation()}>
            {piLoginModal.loading ? (
              <>
                <div style={{
                  width: '32px',
                  height: '32px',
                  border: '3px solid #e0e0e0',
                  borderTop: '3px solid #6C5CE7',
                  borderRadius: '50%',
                  animation: 'spin 0.8s linear infinite',
                  margin: '0 auto 16px'
                }} />
                <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                <ModalMessage style={{ marginBottom: 0 }}>
                  {piLoginModal.message}
                </ModalMessage>
              </>
            ) : (
              <>
                <ModalMessage style={{ whiteSpace: 'pre-wrap' }}>
                  {piLoginModal.message}
                </ModalMessage>
                <ModalActions>
                  <ModalButton
                    onClick={() => setPiLoginModal({ show: false, loading: false, message: '', type: 'info' })}
                  >
                    {t(SPOT_MESSAGES.CONFIRM)}
                  </ModalButton>
                </ModalActions>
              </>
            )}
          </ModalContent>
        </ModalOverlay>
      )}

      {/* 🎯 [성능 개선] GPS 정밀 위치 갱신 토스트 알림 */}
      {gpsToast.show && (
        <div style={{
          position: 'fixed',
          top: '60px',
          left: '50%',
          transform: 'translateX(-50%)',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          padding: '5px 10px',
          borderRadius: '12px',
          fontSize: '10px',
          fontWeight: '500',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
          zIndex: 9999,
          animation: 'fadeInOut 3s ease-in-out'
        }}>
          <style>{`
            @keyframes fadeInOut {
              0% { opacity: 0; transform: translateX(-50%) translateY(-10px); }
              15% { opacity: 1; transform: translateX(-50%) translateY(0); }
              85% { opacity: 1; transform: translateX(-50%) translateY(0); }
              100% { opacity: 0; transform: translateX(-50%) translateY(-10px); }
            }
          `}</style>
          {gpsToast.message}
        </div>
      )}

      {isWalkLaunching && !isTreasureHuntMode && (myPos || permissionStatus === 'granted') && (
        <LoadingOverlay message={t(SPOT_MESSAGES.LOCATION_CHECKING)} />
      )}

      {/* 🎯 [NEW] Treasure Hunt Mode Overlay - Full Screen */}
      {isTreasureHuntMode && (
        <TreasureHuntOverlay
          onClose={() => {
            exitTreasureHuntMode();
            finishWalkSession(true);
          }}
          myPos={myPos}
          spots={filteredSpots}
          pointSpots={pointSpots.filter(ps => {
            if (claimedSpotIds.has(ps.id)) return false;
            if (ps.isLandmarkPointSpot) return true;
            if (!myPos || !ps.lat || !ps.lng) return false;
            const R = 6371000;
            const φ1 = myPos.lat * Math.PI / 180, φ2 = ps.lat * Math.PI / 180;
            const Δφ = (ps.lat - myPos.lat) * Math.PI / 180, Δλ = (ps.lng - myPos.lng) * Math.PI / 180;
            const a = Math.sin(Δφ / 2) ** 2 + Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) ** 2;
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            // 일반 선물상자는 내 위치 기준 150m 이내만 표시
            return (R * c) <= 150;
          })}
          onPointSpotClaimed={(id) => setClaimedSpotIds(prev => new Set([...prev, id]))}
          useKakaoMap={useKakaoMap}
          onToggleMap={() => setUseKakaoMap(!useKakaoMap)}
          mapTarget={mapTarget}
          setMapTarget={setMapTarget}
          distanceRadius={distanceRadius}
          onOpenDetail={handleOpenDetail}
          onPointSpotClick={handlePointSpotClick} // 🎯 [FIX] Restore missing prop for Mainnet interaction
          piUser={piUser}
          environment={environment}
        />
      )}

      {/* CITY 데이터는 처음 열 때 조회하고, 이후 상태는 유지한다. */}
      {(hasOpenedCityModal || showCityModal) && (
        <CityModal isOpen={showCityModal} onClose={() => setShowCityModal(false)} />
      )}

      {/* 🎯 [Refactor] Modal rendering moved to SpotDetailModal component (line ~2401) */}

      {/* --- Verification Modal (Existing) --- */}

      <HeaderArea>
        <TopBar>
          {/* Left: Map and notifications */}
          <FlexRow $gap="8px">
            <MapToggleButton onClick={() => {
              rememberMapChoice(!viewMap);
            }}>
              {viewMap ? <IoClose size={18} /> : <IoMapOutline size={18} />}
            </MapToggleButton>

            {/* Notification moved to search position */}
            <NotificationButton onClick={() => setShowAnnouncementModal(true)} $hasUnread={hasUnreadAnnouncements}>
              <IoNotifications size={18} />
              {hasUnreadAnnouncements && <RedDot />}
            </NotificationButton>

            <div style={{ marginLeft: '-4px' }}>
              <TreasureHuntButton
                onClick={() => setShowReferralModal(true)}
                ariaLabel={t(REFERRAL_KEYS.MODAL_TITLE)}
                size={34}
              />
            </div>
          </FlexRow>

          {/* Center: Radar Info & Toggle + Map/Compass (Top Left) */}
          <CenteredContainer $gap="6px">
            <RadarStatusText>
              {t(SPOT_MESSAGES.RADAR_COUNT, { count: filteredSpots.length })}
            </RadarStatusText>
            <RadarHandle onClick={() => {
              if (showRadar) rememberMapChoice(false);
              setShowRadar(!showRadar);
            }}>
              {showRadar ? <IoChevronUp size={14} /> : <IoChevronDown size={14} />}
            </RadarHandle>
          </CenteredContainer>

          {/* Right: User Badge or Pi Login Button */}
          <FlexRow $gap="8px">
            {/* ✅ Phase 2: SPOT 포인트 우선 표시 + 클릭 확장 */}
            {piUser ? (
              <RelativeContainer $cursor="pointer" onClick={() => setShowCurrencyModal(true)}>
                {/* 기본: SPOT 포인트만 표시 */}
                <UserBadge style={{ justifyContent: 'space-between', paddingLeft: '8px', paddingRight: '12px', width: '90px' }}>
                  <SpotCoinIcon width={14} height={14} />
                  <PointText style={{ color: '#FFFFFF', textAlign: 'right', flex: 1 }}>
                    {spotPoints ? spotPoints.toLocaleString() : 0}
                  </PointText>
                </UserBadge>
              </RelativeContainer>
            ) : (
              <PiLoginButton onClick={() => {
                // 🎯 [수동 로그인] 15초 타임아웃으로 Pi 인증 시도

                // 🎯 [Debug] SDK 상태 확인
                if (!PiAdapter.isReady()) {
                  console.warn('[Pi Manual Login] SDK Not Ready:', {
                    hasWindowPi: !!window.Pi,
                    userAgent: navigator.userAgent
                  });
                  setPiLoginModal({ show: true, loading: false, message: `${t(SPOT_MESSAGES.PI_BROWSER_ONLY)} (SDK Not Loaded)`, type: 'error' });
                  return;
                }

                // Connecting... 모달 표시
                setPiLoginModal({ show: true, loading: true, message: t(SPOT_MESSAGES.CONNECTING), type: 'loading' });

                const scopes = ['username', 'payments', 'wallet_address'];
                const onIncompletePaymentFound = async (payment) => {
                  console.log('[Pi Manual Login] Incomplete payment detected - recovering:', payment?.identifier);
                  await handleIncompletePayment(payment, environment);
                };

                // 15초 타임아웃 (권한 팝업 대기 시간은 Pi SDK가 자체 처리)
                const timeoutPromise = new Promise((_, reject) =>
                  setTimeout(() => reject(new Error('Connection timeout')), 15000)
                );

                Promise.race([
                  PiAdapter.authenticate(scopes, onIncompletePaymentFound),
                  timeoutPromise
                ]).then((authResult) => {
                  if (authResult?.user) {
                    sessionStorage.setItem('pi-username', authResult.user.username);
                    sessionStorage.setItem('pi-user-id', authResult.user.uid);
                    sessionStorage.setItem('user-type', 'pi');
                    if (authResult.accessToken) {
                      sessionStorage.setItem('pi-access-token', authResult.accessToken);
                    }
                    setPiLoginModal({ show: false, loading: false, message: '', type: 'info' });
                    // [수정] 새로고침 없이 상태 즉시 업데이트
                    window.dispatchEvent(new CustomEvent('pi-login-success', { detail: authResult.user }));
                  }
                }).catch((error) => {
                  console.error('[Pi Manual Login] Failed:', error);
                  // 🎯 [Fix] 상세 에러 메시지 표시
                  const errMsg = error.message || (typeof error === 'object' ? JSON.stringify(error) : String(error));
                  setPiLoginModal({
                    show: true,
                    loading: false,
                    message: `${t(SPOT_MESSAGES.PI_LOGIN_FAILED)}\n[${errMsg}]`,
                    type: 'error'
                  });
                });
              }}>
                <IoWarning style={{ color: '#FF3B30', fontSize: '14px', marginRight: '4px', verticalAlign: 'middle' }} />
                <span style={{ verticalAlign: 'middle' }}>Pi Login</span>
              </PiLoginButton>
            )}
          </FlexRow>
          {loading && <ProgressBar />}
        </TopBar>

        {/* DB 권한 확인 중에만 화면을 막는다. 스팟 백그라운드 갱신은 ProgressBar로 표시한다. */}
        {isCheckingDb && !showRegModal && !showEditModal && !detailedSpot && (
          <LoadingOverlay message={t(SPOT_MESSAGES.CHECKING_PERMISSION)} />
        )}

        {/* Map View - Kakao for Korea, Leaflet for elsewhere */}
        {/* 🎯 [2026-05-10] myPos null이어도 viewMap이면 placeholder 노출 (S2~S5 시나리오)
            - permissionStatus === 'denied': 권한 거부 안내 + REFRESH로 재요청
            - permissionStatus === 'prompt' / 'loading': 위치 잡는 중 안내
            - granted 인데 myPos null: 위치 잡는 중 안내 (재시도 버튼)
            맵이 차지하는 슬롯 자체는 항상 동일 → 레이아웃 점프 없음 */}
        {/* BASE 모드: 세계 지도(Leaflet+OSM) — viewMap 토글로 제어, STORE/LANDMARK와 동일 */}
        {viewMap && isBaseMode && (
          <BaseLeafletMap
            baseList={baseManager.baseList}
            panToCityId={mapPanCityId}
            myPos={myPos}
            onCitySelect={(cityId) => {
              const listEl = document.querySelector('[data-base-city="' + cityId + '"]');
              if (listEl) listEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }}
            height={isMapExpanded ? 360 : 180}
          />
        )}

        {viewMap && !isBaseMode && (
          <div style={{
            position: 'relative',
            height: isMapExpanded ? '360px' : '180px',
            width: '100%',
            zIndex: 10,
            background: '#f0f0f0',
            transition: 'all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
          }}>
            {/* 🗺️ myPos가 있으면 실제 맵, 없으면 placeholder */}
            {myPos ? (
            <UnifiedMapView
              center={myPos}
              spots={filteredSpots}
              selectedSpotId={selectedMapSpotId}
              onSpotClick={handleMapMarkerClick} // 🎯 [UX] 마커 클릭 시 피드로 이동 + 보라색 강조
              myPos={myPos}
              isExpanded={isMapExpanded}
              mapTarget={mapTarget}
              useKakao={useKakaoMap}
              onToggleMap={() => setUseKakaoMap(!useKakaoMap)}
              setOffScreenIndicator={setOffScreenIndicator}
              distanceRadius={distanceRadius} // 🎯 [NEW] Map zoom based on distance
              // 🎯 [New] Point Spot Props & Map Ref
              pointSpots={pointSpots.filter(ps => !claimedSpotIds.has(ps.id))}
              onPointSpotClick={handlePointSpotClick} // 🎯 [Add]
              onMapReady={(map) => { mapRef.current = map; }} // 🎯 [NEW] 지도 인스턴스 저장
              isTreasureHuntMode={isTreasureHuntMode} // 🎯 [FIX] 줌 레벨 제어를 위해 모드 전달
            />
            ) : (
              <div style={{
                position: 'absolute',
                inset: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '10px',
                background: 'linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)',
                color: '#4B5563'
              }}>
                {permissionStatus === 'denied' ? (
                  <>
                    <div style={{ fontSize: '2rem', opacity: 0.6 }}>📍</div>
                    <div style={{ fontSize: '0.9rem', textAlign: 'center', padding: '0 16px', lineHeight: 1.4 }}>
                      {t('spot_location_blocked', '위치 권한이 차단되어 지도를 표시할 수 없습니다.')}
                    </div>
                    <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
                      <button
                        onClick={() => { showAlert(t(SPOT_MESSAGES.PERMISSION_BLOCKED)); }}
                        style={{
                          padding: '8px 14px', borderRadius: '20px',
                          border: '1px solid #D1D5DB', background: '#fff', color: '#374151',
                          fontSize: '0.8rem', fontWeight: 600, cursor: 'pointer'
                        }}>
                        {t('spot_help_label', '도움말')}
                      </button>
                      <button
                        onClick={() => handleScan(null, false, true)}
                        style={{
                          padding: '8px 14px', borderRadius: '20px',
                          border: 'none', background: '#7C3AED', color: '#fff',
                          fontSize: '0.8rem', fontWeight: 600, cursor: 'pointer',
                          display: 'flex', alignItems: 'center', gap: '4px'
                        }}>
                        <IoSync size={14} /> REFRESH
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <div style={{
                      width: '28px', height: '28px',
                      border: '3px solid #D1D5DB',
                      borderTopColor: '#7C3AED',
                      borderRadius: '50%',
                      animation: 'spotgo-spin 0.9s linear infinite'
                    }} />
                    <div style={{ fontSize: '0.85rem' }}>
                      {t('spot_loading_position', '위치 잡는 중...')}
                    </div>
                    <button
                      onClick={() => handleScan(null, false, true)}
                      style={{
                        marginTop: '4px', padding: '6px 14px', borderRadius: '16px',
                        border: '1px solid #D1D5DB', background: '#fff', color: '#374151',
                        fontSize: '0.78rem', fontWeight: 600, cursor: 'pointer',
                        display: 'flex', alignItems: 'center', gap: '4px'
                      }}>
                      <IoSync size={12} /> REFRESH
                    </button>
                    <style>{`@keyframes spotgo-spin { to { transform: rotate(360deg); } }`}</style>
                  </>
                )}
              </div>
            )}


            {/* Off-screen Indicator */}
            {/* New Fixed Off-screen Indicator */}
            {offScreenIndicator.angle !== null && (
              <div
                onClick={(e) => {
                  console.log('[SpotGoMain] Indicator Clicked', myPos); // 🎯 DEBUG
                  e.stopPropagation(); // 🎯 FIX: Prevent bubbling
                  if (myPos) {
                    setMapTarget([myPos.lat, myPos.lng, Date.now()]);
                  }
                }}
                style={{
                  position: 'absolute',
                  top: 'auto',
                  bottom: '16px',
                  left: '16px',
                  zIndex: 1000,
                  pointerEvents: 'auto', // Ensure clickable
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '4px',
                  cursor: 'pointer'
                }}
              >
                <div style={{
                  width: '40px', height: '40px',
                  background: 'white',
                  borderRadius: '50%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                  border: `2px solid ${THEME.primary}`,
                  transform: `rotate(${offScreenIndicator.angle}deg)`,
                  transition: 'transform 0.1s linear'
                }}>
                  <IoArrowUp size={24} color={THEME.primary} />
                </div>
                <div style={{
                  background: 'rgba(0,0,0,0.7)', color: 'white',
                  padding: '4px 8px', borderRadius: '12px',
                  fontSize: '0.75rem', fontWeight: 'bold',
                  backdropFilter: 'blur(4px)',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                }}>
                  {offScreenIndicator.distance}
                </div>
              </div>
            )}

            {/* Expand/Contract Map Button - placeholder 상태(myPos 없음)에서는 숨김 */}
            {myPos && (
              <button
                onClick={() => setIsMapExpanded(!isMapExpanded)}
                style={{
                  position: 'absolute',
                  bottom: '16px',
                  right: '16px',
                  zIndex: 1000,
                  background: 'white',
                  border: '1px solid #E5E7EB',
                  borderRadius: '8px',
                  padding: '8px',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  cursor: 'pointer'
                }}
              >
                {isMapExpanded ? <IoContract size={20} color="#374151" /> : <IoExpand size={20} color="#374151" />}
              </button>
            )}

            {/* Old Indicator (Disabled) */}
            {false && offScreenIndicator.angle !== null && (
              <div style={{
                position: 'absolute', top: '50%', left: '50%',
                /* Adjust distance based on Expand state to push to edges */
                transform: `translate(-50%, -50%) rotate(${offScreenIndicator.angle}deg) translateY(${isMapExpanded ? '-38vh' : '-85px'})`,
                zIndex: 1000, pointerEvents: 'none', transition: 'transform 0.1s linear'
              }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px' }}>
                  {/* Distance (Counter Rotate) */}
                  <div style={{
                    transform: `rotate(${-offScreenIndicator.angle}deg)`,
                    background: 'rgba(0,0,0,0.7)', color: 'white', padding: '2px 8px', borderRadius: '12px',
                    fontSize: '0.7rem', fontWeight: 'bold', marginBottom: '4px', backdropFilter: 'blur(4px)',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                  }}>
                    {offScreenIndicator.distance}
                  </div>
                  {/* Arrow (Points UP = OUT because container is rotated) */}
                  <div style={{
                    width: '32px', height: '32px', background: 'white', borderRadius: '50%',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.3)', border: `2px solid ${THEME.primary}`
                  }}>
                    <IoArrowUp size={20} color={THEME.primary} />
                  </div>
                </div>
              </div>
            )}

          </div>
        )
        }

        {/* Radar View (Collapsible) - New Left/Right Layout */}
        <RadarContainer
          $show={showRadar && !viewMap}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          {/* Left: TOP 5 with STORE/LAND Tab - Horizontal Layout */}
          <div style={{ flex: '0 0 45%', maxWidth: '155px', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', paddingLeft: '16px', paddingTop: '0px', paddingBottom: '2px', minWidth: 0, height: '160px' }}>
            {/* Top 5 Title + Tabs in same row */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '6px', marginBottom: '5px', width: '100%' }}>
              {/* Tab Switcher */}
              <div style={{ display: 'flex', gap: '2px', flex: 1 }}>
                {['stores', 'landmarks', 'bases'].map((tab) => (
                  <button
                    key={tab}
                    onClick={() => setTopListTab(tab)}
                    style={{
                      background: topListTab === tab ? 'rgba(255,255,255,0.85)' : 'rgba(255,255,255,0.25)',
                      border: '1px solid rgba(255,255,255,0.4)',
                      borderRadius: '5px',
                      padding: '4px 6px',
                      fontSize: '0.58rem',
                      fontWeight: '700',
                      color: topListTab === tab ? '#5B4B9E' : '#E8E0FF',
                      cursor: 'pointer',
                      transition: 'all 0.2s',
                      flex: 1
                    }}
                  >
                    {tab === 'stores' ? 'STORE' : tab === 'landmarks' ? 'LAND' : 'BASE'}
                  </button>
                ))}
              </div>

            </div>

            {/* List Items - Compact */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', flex: 1, minHeight: '85px' }}>
              {topListTab === 'bases' ? (
                (() => {
                  const ownerRates = {};
                  const nowMs = Date.now();
                  (baseManager.baseList || []).forEach((base) => {
                    (base.statuses || []).forEach((status) => {
                      if (!status?.ownerId) return;
                      const hourly = estimateHourlySpot(status, baseManager.config, nowMs);
                      if (hourly <= 0) return;
                      if (!ownerRates[status.ownerId]) {
                        ownerRates[status.ownerId] = { hourly: 0, name: status.ownerName || 'Unknown' };
                      }
                      ownerRates[status.ownerId].hourly += hourly;
                    });
                  });
                  const topOwners = Object.entries(ownerRates)
                    .map(([ownerId, d]) => ({ ownerId, hourly: d.hourly, name: d.name }))
                    .sort((a, b) => b.hourly - a.hourly)
                    .slice(0, 5);
                  const myHourly = (piUser?.uid && ownerRates[piUser.uid]?.hourly) || 0;
                  const formatHourly = (value) => Number(value || 0).toLocaleString(undefined, {
                    minimumFractionDigits: 4,
                    maximumFractionDigits: 4
                  });

                  return topOwners.length > 0 ? (
                    <>
                      {topOwners.map((owner, i) => {
                    const rankIcons = ['🥇', '🥈', '🥉'];
                    return (
                      <div
                        key={owner.ownerId}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '2px',
                          padding: '3px 4px',
                          borderRadius: '6px',
                          background: 'rgba(100, 90, 160, 0.4)',
                          backdropFilter: 'blur(6px)',
                          fontSize: '0.58rem',
                          transition: 'all 0.2s',
                          border: '1px solid rgba(255, 255, 255, 0.15)'
                        }}
                      >
                        <span style={{ minWidth: '14px', fontSize: i < 3 ? '0.75rem' : '0.6rem', textAlign: 'center', fontWeight: '700', color: i >= 3 ? 'rgba(255,255,255,0.8)' : 'inherit' }}>
                          {i < 3 ? rankIcons[i] : (i + 1)}
                        </span>
                        <span style={{ color: '#FFFFFF', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontWeight: i === 0 ? '700' : '500', flex: 1, minWidth: 0 }}>
                          {maskNickname(owner.name)}
                        </span>
                        <span style={{ color: '#FFD700', fontSize: '0.42rem', fontWeight: '600', flexShrink: 0, whiteSpace: 'nowrap' }}>
                          {t(BASE_KEYS.RANK_SPOT, { amount: formatHourly(owner.hourly) })}
                        </span>
                        <CityIcon userId={owner.ownerId} size={12} style={{ marginLeft: 2, flexShrink: 0 }} />
                      </div>
                    );
                      })}
                      <div style={{ marginTop: 'auto', padding: '4px 2px 0', color: '#FFD700', fontSize: '0.46rem', lineHeight: 1.2, textAlign: 'center', whiteSpace: 'nowrap', fontWeight: '700' }}>
                        {t(BASE_KEYS.RANK_MY_HOURLY, { amount: formatHourly(myHourly) })}
                      </div>
                    </>
                  ) : (
                    <div style={{ fontSize: '0.65rem', color: '#5B4B9E', padding: '12px 10px', textAlign: 'center', background: 'rgba(255,255,255,0.85)', borderRadius: '8px', lineHeight: '1.4', wordBreak: 'keep-all', fontWeight: '800', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', border: '2px solid rgba(255,255,255,0.5)' }}>
                      {t(SPOT_MESSAGES.TOP5_EMPTY_LANDMARKS)}
                    </div>
                  );
                })()
              ) : topListTab === 'landmarks' ? (
                // Landmark ranking - show owner info
                (() => {
                  const landmarksInRadius = filteredSpots.filter(s => s.type === 'landmark');
                  const ownerCounts = {};
                  landmarksInRadius.forEach(land => {
                    const status = landmarkStatus[land.id];
                    if (status?.ownerId) {
                      ownerCounts[status.ownerId] = (ownerCounts[status.ownerId] || 0) + 1;
                    }
                  });
                  const topOwners = Object.entries(ownerCounts)
                    .map(([ownerId, count]) => {
                      const firstLand = landmarksInRadius.find(l => landmarkStatus[l.id]?.ownerId === ownerId);
                      return {
                        ownerId,
                        count,
                        name: landmarkStatus[firstLand?.id]?.ownerName || 'Unknown',
                        id: ownerId // for key
                      };
                    })
                    .sort((a, b) => b.count - a.count)
                    .slice(0, 5);

                  return topOwners.length > 0 ? topOwners.map((owner, i) => {
                    const rankIcons = ['🥇', '🥈', '🥉'];
                    return (
                      <div
                        key={owner.id}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '4px',
                          padding: '4px 8px',
                          borderRadius: '6px',
                          background: 'rgba(100, 90, 160, 0.4)',
                          backdropFilter: 'blur(6px)',
                          fontSize: '0.58rem',
                          transition: 'all 0.2s',
                          border: '1px solid rgba(255, 255, 255, 0.15)'
                        }}
                      >
                        <span style={{
                          minWidth: '14px',
                          fontSize: i < 3 ? '0.75rem' : '0.6rem',
                          textAlign: 'center',
                          fontWeight: '700',
                          color: i >= 3 ? 'rgba(255,255,255,0.8)' : 'inherit'
                        }}>{i < 3 ? rankIcons[i] : (i + 1)}</span>
                        <span style={{
                          color: '#FFFFFF',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          fontWeight: i === 0 ? '700' : '500',
                          flex: 1
                        }}>{maskNickname(owner.name)}</span>
                        <span style={{
                          color: '#FFD700',
                          fontSize: '0.55rem',
                          fontWeight: '600'
                        }}>{owner.count}개</span>
                        <CityIcon userId={owner.ownerId} size={12} style={{ marginLeft: 2 }} />
                      </div>
                    );
                  }) : (
                    <div style={{
                      fontSize: '0.65rem',
                      color: '#5B4B9E',
                      padding: '12px 10px',
                      textAlign: 'center',
                      background: 'rgba(255, 255, 255, 0.85)',
                      borderRadius: '8px',
                      lineHeight: '1.4',
                      wordBreak: 'keep-all',
                      fontWeight: '800',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                      border: '2px solid rgba(255,255,255,0.5)',
                      cursor: 'pointer'
                    }}>
                      {t(SPOT_MESSAGES.TOP5_EMPTY_LANDMARKS)}
                    </div>
                  );
                })()
              ) : (
                topStores.map((s, i) => {
                  const rankIcons = ['🥇', '🥈', '🥉'];
                  return (
                    <div
                      key={s.id}
                      onClick={() => handleOpenDetail(s)}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                        padding: '4px 8px',
                        borderRadius: '6px',
                        background: 'rgba(100, 90, 160, 0.4)',
                        backdropFilter: 'blur(6px)',
                        cursor: 'pointer',
                        fontSize: '0.58rem',
                        transition: 'all 0.2s',
                        border: '1px solid rgba(255, 255, 255, 0.15)'
                      }}
                    >
                      <span style={{
                        minWidth: '14px',
                        fontSize: i < 3 ? '0.75rem' : '0.6rem',
                        textAlign: 'center',
                        fontWeight: '700',
                        color: i >= 3 ? 'rgba(255,255,255,0.8)' : 'inherit'
                      }}>{i < 3 ? rankIcons[i] : (i + 1)}</span>
                      <span style={{
                        color: '#FFFFFF',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        fontWeight: i === 0 ? '700' : '500',
                        flex: 1
                      }}>{getLocalizedTitle(s, i18n.language)}</span>
                    </div>
                  );
                })
              )}
              {topListTab === 'stores' && topStores.length === 0 && (
                <div style={{ fontSize: '0.6rem', color: 'rgba(255,255,255,0.7)', padding: '18px 8px', textAlign: 'center', background: 'rgba(100, 90, 160, 0.25)', borderRadius: '6px', lineHeight: '1.6', wordBreak: 'keep-all' }}>
                  {t(SPOT_MESSAGES.TOP5_EMPTY_STORES)}
                </div>
              )}
            </div>
          </div>

          {/* Right: Radar with integrated SCAN button - Aligned */}
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: '0px', flexShrink: 0, marginRight: '12px' }}>
            {/* Radar Container */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px' }}>
              {/* Radar Wrapper with Cardinal Directions Outside */}
              <div style={{ position: 'relative', padding: '8px' }}>

                {/* Cardinal Directions - Outside radar but rotates with it */}
                <div style={{ position: 'absolute', width: '100%', height: '100%', top: 0, left: 0, pointerEvents: 'none', transform: `rotate(${radarRotation}deg)` }}>
                  <span style={{ position: 'absolute', top: '0px', left: '50%', transform: 'translateX(-50%)', fontSize: '0.6rem', fontWeight: '600', color: 'rgba(255, 255, 255, 0.5)', zIndex: 10 }}>N</span>
                  <span style={{ position: 'absolute', bottom: '0px', left: '50%', transform: 'translateX(-50%)', fontSize: '0.6rem', fontWeight: '600', color: 'rgba(255, 255, 255, 0.5)', zIndex: 10 }}>S</span>
                  <span style={{ position: 'absolute', left: '0px', top: '50%', transform: 'translateY(-50%)', fontSize: '0.6rem', fontWeight: '600', color: 'rgba(255, 255, 255, 0.5)', zIndex: 10 }}>W</span>
                  <span style={{ position: 'absolute', right: '0px', top: '50%', transform: 'translateY(-50%)', fontSize: '0.6rem', fontWeight: '600', color: 'rgba(255, 255, 255, 0.5)', zIndex: 10 }}>E</span>
                </div>

                {/* 🎯 위치 소스 인디케이터 - 레이더 우측 상단 */}
                <div style={{
                  position: 'absolute',
                  top: '-2px',
                  right: '-2px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '2px',
                  fontSize: '6px',
                  color: 'white',
                  background: 'rgba(0,0,0,0.3)',
                  padding: '2px 4px',
                  borderRadius: '6px',
                  zIndex: 20
                }}>
                  <style>{`
                  @keyframes signalPulse {
                    0%, 100% { opacity: 0.7; transform: scale(0.95); }
                    50% { opacity: 1; transform: scale(1.05); }
                  }
                `}</style>
                  <IoWifi size={9} style={{ animation: 'signalPulse 1.2s ease-in-out infinite' }} />
                  <span style={{ fontWeight: '500', fontSize: '5px', marginLeft: '1px' }}>
                    {locationSource === 'gps' ? 'GPS' : 'WiFi'}
                  </span>
                </div>

                <RadarScreen $rotation={radarRotation}>
                  <RadarSweep />
                  <RippleContainer><RippleCircle /></RippleContainer>
                  <CenterAvatarContainer>
                    {piUser?.photoURL ? <CenterAvatarImg src={piUser.photoURL} /> : <IoPerson size={10} color="#374151" />}
                  </CenterAvatarContainer>
                  {filteredSpots.map(spot => {
                    if (!myPos || !spot.geo) return null;
                    const pos = calculateRadarPosition(spot.geo.lat, spot.geo.lng);
                    return (
                      <RadarBlip
                        key={spot.id}
                        style={{ top: pos.top, left: pos.left }}
                        $type={spot.type}
                        $active={selectedSpotId === spot.id}
                      />
                    );
                  })}
                </RadarScreen>
              </div>
              {/* REFRESH Button - Handles Permission Recovery */}
              <ScanButton onClick={() => {
                // 🎯 [Permission Recovery]
                if (permissionStatus === 'denied') {
                  showAlert(t(SPOT_MESSAGES.PERMISSION_BLOCKED));
                  return;
                }
                // 🎯 [Fix] prompt 상태여도 리프레시 허용 (강제 재시도)
                if (!myPos && permissionStatus === 'granted') {
                  // 위치가 없는데 granted라면 재시도
                }

                // Normal Refresh
                handleScan(null, false, true);
              }} style={{ marginTop: '2px', padding: '5px 14px', fontSize: '0.7rem' }}>
                <IoSync size={12} style={{ marginRight: '4px' }} />
                REFRESH
              </ScanButton>
            </div>
          </div>
        </RadarContainer>


      </HeaderArea >

      {/* 🎯 [ToS 제거됨] 약관 동의 모달은 App.js의 TosAgreementModal에서 처리 */}

      {/* Sticky Navigation Bar (Chips + Tabs) - Always Visible */}
      <StickyNav style={{ background: '#F8FAFF' }}>
        {isBaseMode ? (
          <ControlsContainer>
            {myBaseChips.map((chip) => (
              <DistanceChip
                key={chip.key}
                type="button"
                $active={!!chip.cityId}
                disabled={!chip.cityId}
                onClick={() => chip.cityId && focusBaseCity(chip.cityId)}
                style={!chip.cityId ? { cursor: 'default', opacity: 0.7 } : undefined}
              >
                <span style={{ fontSize: '0.8rem', fontWeight: 700 }}>{chip.label}</span>
              </DistanceChip>
            ))}
            <span style={{
              marginLeft: 'auto',
              flexShrink: 0,
              alignSelf: 'center',
              padding: '0 6px',
              color: '#6B7280',
              fontSize: '0.75rem',
              fontWeight: 700,
              whiteSpace: 'nowrap'
            }}>
              {t(BASE_KEYS.MY_SECTION_TITLE)}
            </span>
          </ControlsContainer>
        ) : (
        <ControlsContainer>
          {SPOT_CONSTANTS.RADAR_STEPS.map(dist => {
            const isPremiumChip = dist === SPOT_CONSTANTS.PREMIUM_RADIUS.VALUE;
            const showPremiumTimeInside =
              isPremiumChip &&
              isPremiumUnlocked &&
              premiumTimeLeft &&
              !showPremiumModal &&
              !showCurrencyModal;

            const label =
              dist < 1000 ? `${dist}m` : `${dist / 1000}km`;

            return (
              <div
                key={dist}
                style={{ position: 'relative', overflow: 'visible' }}
              >
                <DistanceChip
                  $active={distanceRadius === dist}
                  $disabled={loading}
                  onClick={() => !loading && handleChipClick(dist)}
                  style={{
                    ...(loading ? { opacity: 0.5, pointerEvents: 'none' } : {}),
                    // 🎯 50km 활성 상태에서만 세로 패딩을 살짝 줄여 기존 칩 높이와 맞춤
                    ...(isPremiumChip && showPremiumTimeInside
                      ? { paddingTop: 4, paddingBottom: 4 }
                      : {})
                  }}
                  data-distance-chip={dist}
                >
                  {/* 🔒 [Premium] Lock icon for 50km when locked */}
                  {isPremiumChip && !isPremiumUnlocked && (
                    <IoLockClosed size={11} style={{ marginRight: '3px', opacity: 0.7 }} />
                  )}

                  {/* 50km 칩 안에 남은 시간까지 콤팩트하게 표시 */}
                  {isPremiumChip && showPremiumTimeInside ? (
                    <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: 1 }}>
                      <span style={{ fontSize: '0.7rem', fontWeight: 700 }}>
                        {label}
                      </span>
                      <span style={{ fontSize: '0.55rem', fontWeight: 700, color: '#FFD700', marginTop: 1 }}>
                        {premiumTimeLeft}
                      </span>
                    </span>
                  ) : (
                    <span style={{ fontSize: '0.8rem', fontWeight: 700 }}>
                      {label}
                    </span>
                  )}
                </DistanceChip>
              </div>
            );
          })}

          <div style={{ position: 'relative', marginLeft: 'auto' }}>
            <button
              ref={mySpotMenuButtonRef}
              onClick={() => setShowMySpotMenu(!showMySpotMenu)}
              style={{
                background: mySpotFilter ? '#6C5CE7' : 'white',
                color: mySpotFilter ? 'white' : '#6C5CE7',
                border: '1px solid #6C5CE7',
                padding: '6px 10px',
                borderRadius: '20px',
                fontSize: '0.75rem',
                fontWeight: '600',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                whiteSpace: 'nowrap'
              }}
            >
              <IoPerson size={12} />
              {mySpotFilter === 'my_store' ? t(SPOT_MESSAGES.FILTER_MY_STORE) :
                mySpotFilter === 'my_land' ? t('my_land_title') :
                  t(SPOT_MESSAGES.FILTER_MY_MENU)}
              <IoChevronDown size={10} style={{ transform: showMySpotMenu ? 'rotate(180deg)' : 'rotate(0)', transition: 'transform 0.2s' }} />
            </button>

            {/* Dropdown Menu - Using Portal to avoid overflow issues */}
            {showMySpotMenu && mySpotMenuButtonRef.current && createPortal(
              <>
                {/* Backdrop to close menu on outside click */}
                <div
                  style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 9999,
                    background: 'transparent'
                  }}
                  onClick={() => setShowMySpotMenu(false)}
                />
                <div style={{
                  position: 'fixed',
                  top: `${mySpotMenuButtonRef.current.getBoundingClientRect().bottom + 4}px`,
                  right: `${window.innerWidth - mySpotMenuButtonRef.current.getBoundingClientRect().right}px`,
                  background: 'white',
                  borderRadius: '12px',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                  padding: '8px 0',
                  zIndex: 10000,
                  minWidth: '140px',
                  border: '1px solid #E5E7EB'
                }}>
                  <button
                    onClick={() => { setMySpotFilter('my_store'); setFilterMode('all'); setShowMySpotMenu(false); }}
                    style={{
                      width: '100%', padding: '10px 16px', border: 'none',
                      background: mySpotFilter === 'my_store' ? 'rgba(108, 92, 231, 0.1)' : 'transparent',
                      color: mySpotFilter === 'my_store' ? '#6C5CE7' : '#374151',
                      fontSize: '0.8rem', fontWeight: mySpotFilter === 'my_store' ? '700' : '500',
                      textAlign: 'left', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px'
                    }}
                  >
                    <IoShieldCheckmark size={14} /> {t(SPOT_MESSAGES.FILTER_MY_STORE)}
                  </button>
                  {/* ✅ Phase 3: My Land 메뉴 - 본인 점유 구역 (랜드마크 + 마이랜드) */}
                  <button
                    onClick={() => { setMySpotFilter('my_land'); setFilterMode('all'); setShowMySpotMenu(false); }}
                    style={{
                      width: '100%', padding: '10px 16px', border: 'none',
                      background: mySpotFilter === 'my_land' ? 'rgba(108, 92, 231, 0.1)' : 'transparent',
                      color: mySpotFilter === 'my_land' ? '#6C5CE7' : '#374151',
                      fontSize: '0.8rem', fontWeight: mySpotFilter === 'my_land' ? '700' : '500',
                      textAlign: 'left', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px'
                    }}
                  >
                    <IoMapOutline size={14} /> {t('my_land_title')}
                  </button>
                  {/* Clear Filter Option */}
                  {mySpotFilter && (
                    <button
                      onClick={() => { setMySpotFilter(null); setShowMySpotMenu(false); }}
                      style={{
                        width: '100%', padding: '10px 16px', border: 'none',
                        borderTop: '1px solid #E5E7EB',
                        marginTop: '4px',
                        background: 'transparent',
                        color: '#EF4444',
                        fontSize: '0.8rem', fontWeight: '500',
                        textAlign: 'left', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px'
                      }}
                    >
                      <IoClose size={14} /> {t(SPOT_MESSAGES.FILTER_CLEAR)}
                    </button>
                  )}
                </div>
              </>,
              document.body
            )}
          </div>

        </ControlsContainer>
        )}

        <TabsHeader>
          <Tab $active={activeTab === 'all'} onClick={() => setActiveTab('all')}>ALL</Tab>
          <div style={{ width: 1, height: 14, background: '#C9CAD0', flexShrink: 0 }} />
          <Tab $active={activeTab === 'store'} onClick={() => setActiveTab('store')}>STORE</Tab>
          <div style={{ width: 1, height: 14, background: '#C9CAD0', flexShrink: 0 }} />
          <Tab $active={activeTab === 'landmark'} onClick={() => setActiveTab('landmark')}>LANDMARK</Tab>
          <div style={{ width: 1, height: 14, background: '#C9CAD0', flexShrink: 0 }} />
          <Tab $active={activeTab === 'base'} onClick={() => setActiveTab('base')}>{t(BASE_KEYS.TAB_LABEL)}</Tab>
          {/* Sort Button - 랜드마크 탭에서는 CITY 버튼 표시 */}
          {filterMode === 'landmark' ? (
            <div style={{ position: 'relative', marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
              <button
                onClick={() => setShowCityModal(true)}
                style={{
                  background: 'linear-gradient(135deg, #FFD700 0%, #FFBA00 50%, #FFA500 100%)',
                  border: 'none',
                  borderRadius: '6px',
                  padding: '0 10px',
                  height: 28,
                  fontSize: '0.65rem',
                  fontWeight: '600',
                  color: '#1a1a1a',
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 5,
                  lineHeight: 0,
                  boxShadow: '0 2px 8px rgba(255, 186, 0, 0.4)'
                }}
              >
                <span style={{ display: 'inline-flex', alignItems: 'center', lineHeight: 0 }}>
                  <IoBusiness size={14} color="#1a1a1a" />
                </span>
                <span style={{ lineHeight: 1, display: 'inline-block' }}>{t(CITY_KEYS.BTN_LABEL)}</span>
              </button>
            </div>
          ) : filterMode === 'base' ? (
            <div style={{ position: 'relative', marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
              <button
                onClick={() => setShowCityModal(true)}
                style={{
                  background: 'linear-gradient(135deg, #FFD700 0%, #FFBA00 50%, #FFA500 100%)',
                  border: 'none',
                  borderRadius: '6px',
                  padding: '0 10px',
                  height: 28,
                  fontSize: '0.65rem',
                  fontWeight: '600',
                  color: '#1a1a1a',
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 5,
                  lineHeight: 0,
                  boxShadow: '0 2px 8px rgba(255, 186, 0, 0.4)'
                }}
              >
                <span style={{ display: 'inline-flex', alignItems: 'center', lineHeight: 0 }}>
                  <IoBusiness size={14} color="#1a1a1a" />
                </span>
                <span style={{ lineHeight: 1, display: 'inline-block' }}>{t(CITY_KEYS.BTN_LABEL)}</span>
              </button>
            </div>
          ) : (
            <div style={{ position: 'relative', marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
              <button
                onClick={() => setShowSortPopup(!showSortPopup)}
                style={{
                  background: 'rgba(108, 92, 231, 0.1)',
                  border: '1px solid rgba(108, 92, 231, 0.3)',
                  borderRadius: '6px',
                  padding: '6px 10px',
                  fontSize: '0.65rem',
                  fontWeight: '600',
                  color: '#6C5CE7',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '3px',
                  lineHeight: 1
                }}
              >
                <IoSwapVertical size={12} />
                {sortBy === 'popular' && t(SPOT_MESSAGES.SORT_POPULAR)}
                {sortBy === 'distance' && t(SPOT_MESSAGES.SORT_DISTANCE)}
                {sortBy === 'newest' && t(SPOT_MESSAGES.SORT_NEWEST)}
              </button>
              {/* Sort Popup */}
              {showSortPopup && (
                <div style={{
                  position: 'absolute',
                  top: '100%',
                  right: 0,
                  marginTop: '4px',
                  background: 'white',
                  borderRadius: '8px',
                  boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
                  padding: '4px 0',
                  zIndex: 200,
                  minWidth: '100px'
                }}>
                  {/* 인기순 */}
                  <button
                    onClick={() => { setSortBy('popular'); setShowSortPopup(false); }}
                    style={{
                      width: '100%',
                      padding: '8px 12px',
                      border: 'none',
                      background: sortBy === 'popular' ? 'rgba(108, 92, 231, 0.1)' : 'transparent',
                      color: sortBy === 'popular' ? '#6C5CE7' : '#374151',
                      fontSize: '0.7rem',
                      fontWeight: sortBy === 'popular' ? '700' : '500',
                      textAlign: 'left',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px'
                    }}
                  >
                    {sortBy === 'popular' && <IoCheckmark size={12} />}
                    {t(SPOT_MESSAGES.SORT_POPULAR)}
                  </button>
                  {/* 거리순 */}
                  <button
                    onClick={() => { setSortBy('distance'); setShowSortPopup(false); }}
                    style={{
                      width: '100%',
                      padding: '8px 12px',
                      border: 'none',
                      background: sortBy === 'distance' ? 'rgba(108, 92, 231, 0.1)' : 'transparent',
                      color: sortBy === 'distance' ? '#6C5CE7' : '#374151',
                      fontSize: '0.7rem',
                      fontWeight: sortBy === 'distance' ? '700' : '500',
                      textAlign: 'left',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px'
                    }}
                  >
                    {sortBy === 'distance' && <IoCheckmark size={12} />}
                    {t(SPOT_MESSAGES.SORT_DISTANCE)}
                  </button>
                  {/* 최신순 (신규) */}
                  <button
                    onClick={() => { setSortBy('newest'); setShowSortPopup(false); }}
                    style={{
                      width: '100%',
                      padding: '8px 12px',
                      border: 'none',
                      background: sortBy === 'newest' ? 'rgba(108, 92, 231, 0.1)' : 'transparent',
                      color: sortBy === 'newest' ? '#6C5CE7' : '#374151',
                      fontSize: '0.7rem',
                      fontWeight: sortBy === 'newest' ? '700' : '500',
                      textAlign: 'left',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px'
                    }}
                  >
                    {sortBy === 'newest' && <IoCheckmark size={12} />}
                    {t(SPOT_MESSAGES.SORT_NEWEST)}
                  </button>
                </div>
              )}
            </div>
          )}
        </TabsHeader>
      </StickyNav>

      <FeedList>
        {filterMode === 'base' ? (
          <BaseList
            baseList={baseManager.baseList}
            config={baseManager.config}
            loading={baseManager.loading}
            error={baseManager.error}
            actionLoadingCityId={baseManager.actionLoadingCityId}
            piUser={piUser}
            onCapture={baseManager.captureBase}
            onReserve={baseManager.reserveCity}
            onCancelReservation={baseManager.cancelReservation}
            ownsGenesis={baseManager.ownsGenesis}
            myReservation={baseManager.myReservation}
            myReservations={baseManager.myReservations}
            showConfirm={showConfirm}
            onCityClick={(cityId) => setMapPanCityId(cityId)}
            myPos={myPos}
            ticketCount={ticketCount}
          />
        ) : (
          <>
        {filteredSpots.slice(0, visibleCount).map(spot => (
          <SpotCard
            id={`spot-card-${spot.id}`}  // 🎯 지도 마커 클릭 시 스크롤 타겟
            key={spot.id}
            $type={spot.type}
            onClick={() => handleOpenDetail(spot)}
            style={{ opacity: spot.spotStatus === 'inactive' ? 0.6 : 1 }} // 🎯 [15/30일 정책] Inactive 스타일
          >
            <CardHeader>
              <TypeBadge $type={spot.type}>
                {spot.type === 'store' && <IoShieldCheckmark />}
                {spot.type === 'footprint' && <IoLocationSharp />}
                {spot.type === 'landmark' && <IoMapOutline />}
                {spot.type === 'store' && ' STORE'}
                {spot.type === 'footprint' && ' POST'}
                {spot.type === 'landmark' && ' LANDMARK'}
              </TypeBadge>
              {/* 🎯 [15/30일 정책] Inactive 배지 표시 */}
              {/* 🎯 [15/30일 정책] 만료 임박 표시 (남은 시간) - 본인 작성 스팟에만 표시 */}
              {spot.spotStatus === 'inactive' &&
                (spot.userId === piUser?.uid || spot.userName === piUser?.username) &&
                (() => {
                  const now = new Date();
                  const createdAt = spot.createdAt?.toDate ? spot.createdAt.toDate() :
                    (spot.createdAt ? new Date(spot.createdAt) : null);

                  if (!createdAt || isNaN(createdAt.getTime())) return null;

                  // 🎯 [Fix] createdAt 기준으로 15일 경과 여부 체크
                  const daysSinceCreated = (now - createdAt) / (1000 * 60 * 60 * 24);

                  // 🎯 [Fix] 처음 15일간은 표시하지 않음 (lastActiveAt 갱신과 무관하게 createdAt 기준)
                  if (daysSinceCreated <= 15) return null;

                  // 🎯 [Fix] 만료 시간은 lastActiveAt 기준으로 계산 (좋아요/인증 시 갱신됨)
                  // 단, createdAt 기준 15일이 지나야 표시되므로, lastActiveAt이 갱신되어도
                  // 만료 시간은 lastActiveAt + 30일로 계산하되, 표시는 createdAt 기준 15일 경과 후에만
                  const lastActive = spot.lastActiveAt?.toDate ? spot.lastActiveAt.toDate() :
                    (spot.lastActiveAt ? new Date(spot.lastActiveAt) : createdAt);

                  // 🎯 [Critical Fix] lastActiveAt이 갱신되어도, 만료 시간은 lastActiveAt 기준으로 계산
                  // 하지만 표시는 createdAt 기준 15일 경과 후에만 표시
                  const expiration = new Date(lastActive.getTime() + (30 * 24 * 60 * 60 * 1000));
                  const diff = expiration - now;
                  const days = Math.max(0, Math.floor(diff / (1000 * 60 * 60 * 24)));
                  const hours = Math.max(0, Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));

                  return (
                    <span
                      onClick={(e) => {
                        e.stopPropagation();
                        setExpiryInfoType(spot.type === 'footprint' ? 'post' : 'store');
                        setShowExpiryInfoModal(true);
                      }}
                      style={{
                        fontSize: '0.65rem',
                        color: '#EF4444', // Red for urgency
                        background: 'rgba(239, 68, 68, 0.1)',
                        padding: '2px 6px',
                        borderRadius: '4px',
                        fontWeight: '600',
                        marginLeft: 'auto',
                        cursor: 'pointer',
                        transition: 'opacity 0.2s'
                      }}
                      onMouseEnter={(e) => e.target.style.opacity = '0.8'}
                      onMouseLeave={(e) => e.target.style.opacity = '1'}
                    >
                      {t(SPOT_MESSAGES.EXPIRES_IN, { days, hours })}
                    </span>
                  );
                })()}
            </CardHeader>
            <CardBody>
              {/* 🎯 [UI 개선] 텍스트 좌측, 썸네일 우측 (원래 레이아웃 유지) */}
              <CardTextColumn>
                <CardTitle>{getLocalizedTitle(spot, i18n.language)}</CardTitle>
                <CardContent>{getLocalizedContent(spot, i18n.language)}</CardContent>
              </CardTextColumn>
              <CardImageColumn>
                {spot.thumbnails?.[0] ? (
                  <SpotThumbnail src={spot.thumbnails[0]} />
                ) : (
                  <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F3F4F6', flexDirection: 'column' }}>
                    {/* ✅ Phase 1: 랜드마크는 아이콘 표시, 기타는 SPOT GO */}
                    {/* ✅ Phase 4: Landmark UX Refinement - Status Badge */}
                    {spot.type === 'landmark' ? (() => {
                      const ls = getLandmarkState(spot.id);
                      if (ls.isEmpty) {
                        return (
                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', background: '#F3F4F6' }}>
                            <IoBusiness size={20} color="#14B8A6" />
                            <span style={{ fontSize: '0.6rem', fontWeight: '800', color: '#6B7280', marginTop: '2px', maxWidth: '90%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>FREE</span>
                          </div>
                        );
                      }
                      return (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', background: '#F3F4F6' }}>
                          <IoBusiness size={20} color="#9CA3AF" />
                          <span style={{ fontSize: '0.6rem', fontWeight: '700', color: '#6B7280', marginTop: '4px', maxWidth: '90%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {ls.status?.ownerName || 'User'}
                          </span>
                        </div>
                      );
                    })() : (
                      <>
                        <span style={{ fontSize: '0.9rem', fontWeight: '900', color: '#9CA3AF', letterSpacing: '-0.5px' }}>SPOT</span>
                        <span style={{ fontSize: '0.9rem', fontWeight: '900', color: '#6C5CE7', lineHeight: '0.8' }}>GO</span>
                      </>
                    )}
                  </div>
                )}
              </CardImageColumn>
            </CardBody>
            <CardFooter>
              {/* 🎯 [UI 개선] 좌측: 거리 | 유저닉네임 */}
              <FlexRow $gap="6px">
                <Distance style={{ flexShrink: 0 }}>{spot.distance}</Distance>
                {spot.geo && (
                  <button
                    onClick={(e) => { e.stopPropagation(); handleGoToMap(spot); }}
                    style={{
                      background: '#6C5CE7',
                      border: 'none',
                      borderRadius: '50%',
                      width: '24px',
                      height: '24px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                      flexShrink: 0
                    }}
                    title={t(SPOT_MESSAGES.VIEW_ON_MAP)}
                  >
                    <IoMapOutline size={14} color="white" />
                  </button>
                )}
                {spot.userName && (
                  <>
                    <span style={{ color: '#E5E7EB', fontSize: '0.8rem' }}>|</span>
                    <small style={{
                      color: '#6B7280',
                      fontSize: '0.75rem',
                      maxWidth: '80px',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      display: 'inline-block',
                      verticalAlign: 'middle'
                    }}>
                      {spot.userName}
                    </small>
                  </>
                )}
              </FlexRow>

              {/* 🎯 [UI 개선] 우측: 인증(Store) / 좋아요 / 댓글 - 모두 Gray + 999+ 포맷 + min-width */}
              <FlexRow $gap="8px">
                {spot.type === 'store' && (
                  <span style={{ fontSize: '0.85rem', color: '#6B7280', display: 'flex', alignItems: 'center', gap: '3px', fontWeight: '600', minWidth: '36px' }}>
                    <IoShieldCheckmark size={14} style={{ transform: 'translateY(1px)' }} />
                    {(spot.verificationCount || 0) > 999 ? '999+' : (spot.verificationCount || 0)}
                  </span>
                )}
                {spot.type !== 'landmark' && (
                  <span style={{ fontSize: '0.85rem', color: '#6B7280', display: 'flex', alignItems: 'center', gap: '3px', fontWeight: '600', cursor: 'default', minWidth: '36px' }}>
                    {spot.liked ? <IoHeart style={{ transform: 'translateY(1px)' }} /> : <IoHeartOutline style={{ transform: 'translateY(1px)' }} />} {(spot.likeCount || 0) > 999 ? '999+' : (spot.likeCount || 0)}
                  </span>
                )}
                {spot.type !== 'landmark' && (
                  <span style={{ fontSize: '0.85rem', color: '#6B7280', display: 'flex', alignItems: 'center', gap: '3px', fontWeight: '600', minWidth: '36px' }}>
                    <IoChatbubbleOutline style={{ transform: 'translateY(1px)' }} /> {(spot.commentCount || 0) > 999 ? '999+' : (spot.commentCount || 0)}
                  </span>
                )}
                {/* Spot Go MVP: Landmark visit/claim UI - REMOVED for Phase 4 (Moved to Modal) */}
              </FlexRow>
            </CardFooter>
          </SpotCard>
        ))}
        {filteredSpots.length === 0 && loading && (
          <EmptyState>{t('spot_loading_spots')}</EmptyState>
        )}
        {filteredSpots.length === 0 && !loading && hasEverLoaded && (
          <EmptyState>{t(SPOT_MESSAGES.EMPTY_DATA_REFRESH)}</EmptyState>
        )}
        {/* Load More Button */}
        {visibleCount < filteredSpots.length && (
          <button
            onClick={() => setVisibleCount(prev => prev + 10)}
            style={{
              width: '100%',
              padding: '14px',
              marginTop: '8px',
              background: 'linear-gradient(135deg, #6C5CE7 0%, #A29BFE 100%)',
              border: 'none',
              borderRadius: '12px',
              color: 'white',
              fontSize: '0.9rem',
              fontWeight: '700',
              cursor: 'pointer',
              boxShadow: '0 4px 15px rgba(108, 92, 231, 0.3)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}
          >
            <IoChevronDown size={18} /> Load More ({filteredSpots.length - visibleCount} remaining)
          </button>
        )}
          </>
        )}

      </FeedList>

      {/* Floating Write Button - Hidden when Modal is Open (내 위치 버튼은 선물상자 맵 내부로 이동) */}
      {
        !detailedSpot && filterMode !== 'base' && (
          <>
            <FloatingAddBtn onClick={() => setShowRegModal(true)}>
              <IoAdd size={24} />
            </FloatingAddBtn>
          </>
        )
      }

      {/* Custom Modal - Moved to Bottom */}
      {
        showRegModal && (
          <ModalOverlay data-modal-open="true">
            <RegModalContent>
              {regStep === 0 ? (
                <>
                  <ModalMessage style={{ fontSize: '0.9rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>{t(SPOT_MESSAGES.REG_SELECT_TYPE)}</span>
                    <span style={{ fontSize: '0.85rem', color: '#6366F1', fontWeight: '600' }}>{t(SPOT_MESSAGES.TICKET_OWNED, { count: ticketCount ?? 0 })}</span>
                  </ModalMessage>
                  <RegTypeContainer>
                    <RegTypeButton $selected={regType === 'store'} onClick={() => setRegType('store')}>
                      <IoShieldCheckmark size={24} />
                      <span>{t(SPOT_MESSAGES.REG_TYPE_STORE)}</span>
                      <small>🎫 10</small>
                    </RegTypeButton>
                    <RegTypeButton
                      $selected={regType === 'my_land'}
                      onClick={() => {
                        setRegType('my_land');
                        // 마이랜드의 상태를 초기화하고 첫 번째 이용 가능한 슬롯을 찾습니다.
                        if (!piUser) {
                          showAlert(t('spot_login_required'));
                          return;
                        }
                        const now = Date.now();
                        const getSlotMillis = (ts) => {
                          if (!ts) return 0;
                          if (typeof ts.toMillis === 'function') return ts.toMillis();
                          if (ts.seconds != null) return ts.seconds * 1000;
                          if (typeof ts === 'number') return ts;
                          return 0;
                        };
                        const firstSelectable = [1, 2, 3].find((s) => {
                          const slotState = s >= 2 ? (myLandSlots || {})[`slot${s}`] : null;
                          const isAlreadyRegistered = !!(myLandRegistrations || {})[`slot${s}`];
                          const active = s < 2 || (!!slotState && (slotState.permanent === true || getSlotMillis(slotState.expiresAt) > now));
                          return active && !isAlreadyRegistered;
                        }) || 1;
                        setRegMyLandSlot(firstSelectable);
                        const isFirstReg = !!(myLandRegistrations || {})[`slot${firstSelectable}`];
                        setRegMyLandName(isFirstReg ? myLandRegistrations[`slot${firstSelectable}`].name : '');
                        // 🎯 [UX Fix] Remove auto-advance to Step 1 for consistency
                      }}
                    >
                      <IoMapOutline size={24} />
                      <span>{t(SPOT_MESSAGES.REG_TYPE_MY_LAND)}</span>
                      <small style={{ color: '#EAB308' }}>🎫 {t('my_land_free_label')}</small>
                    </RegTypeButton>
                  </RegTypeContainer>
                  <ModalActions>
                    <ModalButton $secondary onClick={() => setShowRegModal(false)}>{t(SPOT_MESSAGES.CANCEL)}</ModalButton>
                    <ModalButton
                      onClick={() => {
                        if (regType === 'my_land' && !piUser?.uid) {
                          showAlert(t('spot_login_required'));
                          return;
                        }
                        setRegStep(1);
                        setSelectedFiles([]);
                      }}
                    >
                      {t(SPOT_MESSAGES.NEXT)}
                    </ModalButton>
                  </ModalActions>
                </>
              ) : regType === 'my_land' ? (
                /* My Land 등록: 슬롯 선택 + 이름 + 현재 위치로 등록 */
                <>
                  <ModalMessage style={{ margin: 0, paddingBottom: '16px', borderBottom: '1px solid #eee' }}>
                    {t('my_land_register_title')}
                  </ModalMessage>
                  <div style={{ padding: '16px 0' }}>
                    <div style={{ fontSize: '0.85rem', fontWeight: '600', color: '#4B5563', marginBottom: '8px' }}>{t('my_land_slot_select')}</div>
                    <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
                      {[1, 2, 3].map((s) => {
                        const slotState = s >= 2 ? (myLandSlots || {})[`slot${s}`] : null;
                        const isAlreadyRegistered = !!(myLandRegistrations || {})[`slot${s}`];
                        const now = Date.now();
                        // 이슈 5: Timestamp/plain object/number 모두 방어적으로 파싱
                        const getSlotMillis = (ts) => {
                          if (!ts) return 0;
                          if (typeof ts.toMillis === 'function') return ts.toMillis();
                          if (ts.seconds != null) return ts.seconds * 1000;
                          if (typeof ts === 'number') return ts;
                          return 0;
                        };
                        const active = s < 2 || (!!slotState && (slotState.permanent === true || getSlotMillis(slotState.expiresAt) > now));
                        const selectable = active;
                        return (
                          <button
                            key={s}
                            type="button"
                            onClick={() => {
                              if (!active) {
                                if (window.confirm(t('my_land_goto_shop'))) {
                                  setShowRegModal(false);
                                  setRegStep(0);
                                  _onMenuClick('shop');
                                }
                                return;
                              }
                              if (selectable) {
                                setRegMyLandSlot(s);
                                setRegMyLandName(isAlreadyRegistered ? myLandRegistrations[`slot${s}`].name : '');
                              }
                            }}
                            disabled={active && !selectable} // 미구매/기한만료는 disabled 아님 (클릭 이벤트 필요), 등록완료만 disabled
                            style={{
                              flex: 1,
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '2px',
                              padding: '12px 6px',
                              borderRadius: '10px',
                              border: `2px solid ${regMyLandSlot === s ? '#8B5CF6' : '#E5E7EB'}`,
                              background: regMyLandSlot === s ? '#EDE9FE' : (active && selectable ? '#F9FAFB' : '#F3F4F6'),
                              color: regMyLandSlot === s ? '#5B21B6' : (active ? '#374151' : '#9CA3AF'),
                              cursor: active ? 'pointer' : 'not-allowed',
                              opacity: active ? 1 : 0.6,
                              transition: 'all 0.2s',
                            }}
                          >
                            <span style={{ fontSize: '0.85rem', fontWeight: '700', maxWidth: '80px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                              {isAlreadyRegistered && myLandRegistrations[`slot${s}`]?.name ? myLandRegistrations[`slot${s}`].name : (s === 1 ? t('my_land_slot_free') : t('my_land_slot', { n: s }))}
                            </span>
                            {/* 상태 뱃지 영역 */}
                            {s === 1 && !isAlreadyRegistered && (
                              <SlotBadge $status="free">🎫 {t('my_land_free_label')}</SlotBadge>
                            )}
                            {s >= 2 && !active && (
                              <SlotBadge $status="unowned">{t('my_land_unowned_badge')}</SlotBadge>
                            )}
                            {s >= 2 && active && slotState?.permanent && (
                              <SlotBadge $status="permanent">{t('my_land_permanent_badge')}</SlotBadge>
                            )}
                            {s >= 2 && active && slotState?.expiresAt && !slotState?.permanent && (
                              <SlotBadge $status="free">
                                <IoTimeOutline size={10} style={{ verticalAlign: 'middle', marginRight: '2px' }}/>
                                {t('my_land_days_remaining', { days: Math.max(0, Math.floor((getSlotMillis(slotState.expiresAt) - now) / 86400000)) })}
                              </SlotBadge>
                            )}
                            {isAlreadyRegistered && (
                               <SlotBadge $status="registered">{t('my_land_already_reg_badge')}</SlotBadge>
                            )}
                          </button>
                        );
                      })}
                    </div>
                    <div style={{ fontSize: '0.85rem', fontWeight: '600', color: '#4B5563', marginBottom: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span>{t('my_land_input_name_label')}</span>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span style={{ color: '#9CA3AF', fontSize: '0.75rem', fontWeight: '400' }}>{t('my_land_name_max_chars')}</span>
                        {!!(myLandRegistrations || {})[`slot${regMyLandSlot}`] && (
                          <button
                            type="button"
                            onClick={async () => {
                              const cost = 1000;
                              const oldName = myLandRegistrations[`slot${regMyLandSlot}`]?.name || '';
                              const newName = regMyLandName?.trim();

                              if (!newName) {
                                showAlert(t('my_land_input_name_desc'));
                                return;
                              }
                              if (newName === oldName) {
                                showAlert(t('my_land_rename_same_name'));
                                return;
                              }
                              if ((ppPoints || 0) < cost) {
                                showAlert(t('my_land_rename_insufficient'));
                                return;
                              }

                              showConfirm(
                                t('my_land_rename_confirm', { cost: cost, balance: (ppPoints || 0).toLocaleString() }),
                                async () => {
                                  try {
                                    const renameResult = await renameMyLand(piUser.uid, environment, regMyLandSlot, newName, piUser);
                                    if (renameResult?.success !== false) {
                                      showAlert(
                                        t('my_land_rename_success', {
                                          name: newName,
                                          defaultValue: t('my_land_register_success')
                                        })
                                      );
                                      if (renameResult.myLandRegistrations) setMyLandRegistrations(renameResult.myLandRegistrations);
                                      if (renameResult.ppPoints !== undefined) {
                                        setPpPoints(renameResult.ppPoints);
                                        localStorage.setItem(`painori-pp-points-${environment}`, renameResult.ppPoints.toString());
                                      }
                                      setShowRegModal(false);
                                      setRegStep(0);
                                      setRegMyLandName('');
                                    } else {
                                      showAlert(renameResult?.error || t('my_land_rename_insufficient'));
                                    }
                                  } catch (e) {
                                    showAlert(e?.message || t('spot_purchase_failed'));
                                  }
                                },
                                null,
                                'info'
                              );
                            }}
                            style={{
                              padding: '3px 10px', fontSize: '0.72rem', fontWeight: '600',
                              border: '1px solid #8B5CF6', borderRadius: '6px',
                              background: '#F5F3FF', color: '#7C3AED', cursor: 'pointer'
                            }}
                          >
                            {t('my_land_rename_btn')}
                          </button>
                        )}
                      </div>
                    </div>
                    <RegInput
                      placeholder={t('my_land_input_name_desc')}
                      value={regMyLandName}
                      onChange={(e) => {
                        setRegMyLandName(e.target.value.slice(0, 100));
                      }}
                      onTouchStart={(e) => e.stopPropagation()}
                      onClick={(e) => e.stopPropagation()}
                      style={{ marginBottom: '12px' }}
                    />
                    <p style={{ fontSize: '0.75rem', color: '#6B7280', marginBottom: '16px' }}>
                      {myPos?.lat != null ? t('my_land_register_location_hint') : t('spot_permission_denied')}
                    </p>
                  </div>
                  <ModalActions style={{ paddingTop: '12px', borderTop: '1px solid #eee' }}>
                    <ModalButton $secondary onClick={() => { setRegStep(0); setIsRenaming(false); }}>{t(SPOT_MESSAGES.CANCEL)}</ModalButton>
                    <ModalButton
                      onClick={async () => {
                        if (!piUser?.uid) {
                          showAlert(t('spot_login_required'));
                          return;
                        }
                        if (myPos?.lat == null || myPos?.lng == null) {
                          showAlert(t('spot_location_error'));
                          return;
                        }
                        
                        // 기존 점유 상태 체크
                        const mId = `myland_${piUser.uid}_${regMyLandSlot}`;
                        const isCaptured = landmarkStatus[mId] && landmarkStatus[mId].ownerId === piUser.uid;
                        if (isCaptured) {
                          showAlert(t('my_land_already_own'));
                          return;
                        }

                        try {
                            // 신규 등록 모드
                            const nameToRegister = regMyLandName;
                            const regResult = await registerMyLand(piUser.uid, environment, regMyLandSlot, myPos.lat, myPos.lng, nameToRegister, piUser);
                            if (regResult?.myLandRegistrations) {
                              setMyLandRegistrations(regResult.myLandRegistrations);
                            }
                            // A안: 등록 직후 점유 시도 (추가 DB 조회 없이 로컬 상태 즉시 반영)
                            const captureResult = await handleLandmarkVisit(
                              `myland_${piUser.uid}_${regMyLandSlot}`,
                              {
                                type: 'landmark',
                                name: regMyLandName?.trim() || t('my_land_slot', { n: regMyLandSlot }),
                                geo: { lat: myPos.lat, lng: myPos.lng }
                              },
                              { suppressAlert: true }
                            );
                            if (captureResult?.success) {
                              showAlert(t('my_land_capture_success'));
                            } else if (captureResult?.error === 'INSUFFICIENT_TICKETS') {
                              showAlert(t('my_land_registered_no_ticket_capture'));
                            } else if (captureResult?.error === 'LAND_LIMIT') {
                              showAlert(t('my_land_registered_limit_reached'));
                            } else {
                              showAlert(t('my_land_register_success'));
                            }

                            // 등록 후 랜드마크 필터로 전환
                            setMySpotFilter(null);
                            setFilterMode('landmark');
                            setActiveTab('landmark');
                            setTopListTab('landmarks');
                            setShowRegModal(false);
                            setRegStep(0);
                            setRegMyLandName('');
                        } catch (e) {
                          showAlert(t('spot_purchase_failed') || e?.message);
                        }
                      }}
                      disabled={myPos?.lat == null || myPos?.lng == null || !!(myLandRegistrations || {})[`slot${regMyLandSlot}`]}
                    >
                      {!!(myLandRegistrations || {})[`slot${regMyLandSlot}`]
                        ? t('my_land_already_reg_badge')
                        : t('my_land_register_btn')}
                    </ModalButton>
                  </ModalActions>
                </>
              ) : (
                <>
                  <ModalMessage style={{ margin: 0, paddingBottom: '16px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>{regType === 'store' ? t(SPOT_MESSAGES.REG_TITLE_STORE) : t(SPOT_MESSAGES.REG_TITLE_POST)}</span>
                  </ModalMessage>
                  {/* 🎯 [UI FIX] Scrollable Body for Inputs */}
                  <div style={{ padding: '16px 0', overflowY: 'auto', maxHeight: '60vh' }}>
                    <RegInput
                      placeholder={t(SPOT_MESSAGES.REG_PLACEHOLDER_TITLE)}
                      value={forms[regType].title}
                      onChange={(e) => setForms({ ...forms, [regType]: { ...forms[regType], title: e.target.value } })}
                      onTouchStart={(e) => e.stopPropagation()}
                      onClick={(e) => e.stopPropagation()}
                    />
                    <RegTextArea
                      placeholder={t(SPOT_MESSAGES.REG_PLACEHOLDER_CONTENT)}
                      value={forms[regType].content}
                      onChange={(e) => setForms({ ...forms, [regType]: { ...forms[regType], content: e.target.value } })}
                      onTouchStart={(e) => e.stopPropagation()}
                      onClick={(e) => e.stopPropagation()}
                    />
                    {/* Image Upload UI */}
                    <input
                      type="file"
                      id="reg-file-input"
                      multiple
                      accept="image/*"
                      style={{ display: 'none' }}
                      onChange={handleFileSelect}
                    />
                    <ImageUploadPlaceholder onClick={() => document.getElementById('reg-file-input').click()}>
                      <IoAdd size={24} />
                      <span style={{ marginTop: '4px' }}>
                        {t(SPOT_MESSAGES.REG_ADD_PHOTO, { current: selectedFiles.length, max: regType === 'store' ? 5 : 3 })}
                      </span>
                    </ImageUploadPlaceholder>

                    {/* Image Preview List */}
                    {selectedFiles.length > 0 && (
                      <div style={{ display: 'flex', gap: '8px', overflowX: 'auto', padding: '8px 0', marginTop: '4px' }}>
                        {selectedFiles.map((file, idx) => (
                          <div key={idx} style={{ position: 'relative', width: '60px', height: '60px', flexShrink: 0 }}>
                            <img
                              src={URL.createObjectURL(file)}
                              alt="preview"
                              style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px', border: '1px solid #ddd' }}
                            />
                            <button
                              onClick={() => setSelectedFiles(prev => prev.filter((_, i) => i !== idx))}
                              style={{
                                position: 'absolute', top: -5, right: -5,
                                background: 'red', color: 'white', border: 'none',
                                borderRadius: '50%', width: '18px', height: '18px',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: '10px'
                              }}
                            >
                              X
                            </button>
                          </div>
                        ))}
                      </div>
                    )}

                    <div style={{ textAlign: 'left', fontSize: '0.8rem', color: '#666', marginBottom: '8px' }}>
                      {regType === 'store' ? t(SPOT_MESSAGES.REG_WARNING_STORE) : t(SPOT_MESSAGES.REG_WARNING_POST)}
                    </div>
                  </div>

                  <ModalActions style={{ paddingTop: '12px', borderTop: '1px solid #eee' }}>
                    <ModalButton $secondary onClick={() => setRegStep(0)}>{t(SPOT_MESSAGES.PREV)}</ModalButton>
                    <ModalButton onClick={handleRegSubmit}>
                      {regType === 'store' ? t(SPOT_MESSAGES.REG_SUBMIT_STORE) : t(SPOT_MESSAGES.REG_SUBMIT_POST)}
                    </ModalButton>
                  </ModalActions>
                </>
              )}
            </RegModalContent>
          </ModalOverlay>
        )
      }

      {/* 🎯 [NEW] Edit Modal - 수정 모달 */}
      {
        showEditModal && detailedSpot && (
          <ModalOverlay onClick={() => setShowEditModal(false)}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
              <ModalMessage>{detailedSpot.type === 'store' ? t(SPOT_MESSAGES.EDIT_TITLE_STORE) : t(SPOT_MESSAGES.EDIT_TITLE_POST)}</ModalMessage>

              <RegInput
                placeholder={t(SPOT_MESSAGES.INPUT_TITLE)}
                value={editForm.title}
                onChange={(e) => setEditForm({ ...editForm, title: e.target.value })}
                onTouchStart={(e) => e.stopPropagation()}
                onClick={(e) => e.stopPropagation()}
              />
              <RegTextArea
                placeholder={t(SPOT_MESSAGES.REG_PLACEHOLDER_CONTENT)}
                value={editForm.content}
                onChange={(e) => setEditForm({ ...editForm, content: e.target.value })}
                onTouchStart={(e) => e.stopPropagation()}
                onClick={(e) => e.stopPropagation()}
              />

              {/* 🎯 [NEW] Edit Image Section */}
              <div style={{ marginBottom: '16px' }}>
                <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: '#6B7280', marginBottom: '8px' }}>
                  {t(SPOT_MESSAGES.EDIT_IMAGE_LABEL)}
                </label>

                <div style={{ display: 'flex', gap: '8px', overflowX: 'auto', paddingBottom: '4px' }}>
                  {/* 1. Existing Images */}
                  {editForm.existingImages && editForm.existingImages.map((img, idx) => (
                    <div key={`exist-${idx}`} style={{ position: 'relative', width: '60px', height: '60px', flexShrink: 0 }}>
                      <img src={img.thumbnailUrl || img.url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }} />
                      <button
                        onClick={() => {
                          const newExist = [...editForm.existingImages];
                          newExist.splice(idx, 1);
                          setEditForm({ ...editForm, existingImages: newExist });
                        }}
                        style={{ position: 'absolute', top: -4, right: -4, background: 'red', color: 'white', borderRadius: '50%', width: '18px', height: '18px', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px' }}>
                        ✕
                      </button>
                    </div>
                  ))}

                  {/* 2. New Files Preview */}
                  {editForm.newFiles && editForm.newFiles.map((file, idx) => (
                    <div key={`new-${idx}`} style={{ position: 'relative', width: '60px', height: '60px', flexShrink: 0 }}>
                      <img src={URL.createObjectURL(file)} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px', border: '2px solid #4F46E5' }} />
                      <button
                        onClick={() => {
                          const newFiles = [...editForm.newFiles];
                          newFiles.splice(idx, 1);
                          setEditForm({ ...editForm, newFiles });
                        }}
                        style={{ position: 'absolute', top: -4, right: -4, background: 'red', color: 'white', borderRadius: '50%', width: '18px', height: '18px', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px' }}>
                        ✕
                      </button>
                    </div>
                  ))}

                  {/* 3. Add Button (Hidden if Limit Reached) */}
                  {((editForm.existingImages?.length || 0) + (editForm.newFiles?.length || 0)) < 3 && (
                    <label style={{
                      width: '60px', height: '60px', flexShrink: 0, borderRadius: '8px',
                      border: '1px dashed #ccc', display: 'flex', alignItems: 'center', justifyContent: 'center',
                      cursor: 'pointer', background: '#f9fafb'
                    }}>
                      <input
                        type="file"
                        multiple
                        accept="image/*"
                        style={{ display: 'none' }}
                        onChange={(e) => {
                          if (e.target.files) {
                            const added = Array.from(e.target.files);
                            // Double check limit
                            const currentTotal = (editForm.existingImages?.length || 0) + (editForm.newFiles?.length || 0);
                            if (currentTotal + added.length > 3) {
                              showAlert(t(SPOT_MESSAGES.IMAGE_LIMIT_ALERT));
                              return;
                            }
                            setEditForm(prev => ({ ...prev, newFiles: [...(prev.newFiles || []), ...added] }));
                          }
                        }}
                      />
                      <IoAdd size={20} color="#9CA3AF" />
                    </label>
                  )}
                </div>
                <p style={{ fontSize: '0.75rem', color: '#9CA3AF', marginTop: '4px' }}>
                  {t(SPOT_MESSAGES.EDIT_IMAGE_NOTE)}
                </p>
              </div>

              <ModalActions>
                <ModalButton $secondary onClick={() => setShowEditModal(false)}>{t(SPOT_MESSAGES.CANCEL)}</ModalButton>
                <ModalButton onClick={handleSaveEdit}>{t(SPOT_MESSAGES.SAVE)}</ModalButton>
              </ModalActions>
            </ModalContent>
          </ModalOverlay>
        )
      }

      {/* 🎯 [Refactor] Detail Modal 분리 */}
      {/* 🎯 [Phase 4] Conditional Modal Rendering */}
      {
        detailedSpot && (
          (detailedSpot.type === 'landmark' || detailedSpot.type === 'my_land') ? (
            <LandmarkDetailModal
              detailedSpot={detailedSpot}
              piUser={piUser}
              t={t}
              onClose={() => setDetailedSpot(null)}
              landmarkState={getLandmarkState(detailedSpot.id)}
              onVisit={(id) => handleLandmarkVisit(id, detailedSpot)} // 🎯 [Fix] Pass landmark names to hook
              onClaim={handleLandmarkClaim}
              onConfirmVisit={handleLandmarkVisitConfirm}
              onAdVisit={handleAdLandmarkVisit} // 🎯 [Phase 4] Ad Visit Handler
              adVisitLoading={adVisitLoadingId === detailedSpot.id} // 🐛 [Bugfix] 광고 방문 처리 중 버튼 잠금
              currentLang={i18n.language} // 🎯 [Prop]
            />
          ) : (
            <SpotDetailModal
              detailedSpot={detailedSpot}
              piUser={piUser}
              t={t}
              onClose={() => setDetailedSpot(null)}
              onLike={handleLike}
              onVerify={handleVerify}
              onEdit={handleEditSpot}
              onDelete={handleDeleteSpot}
              comments={comments}
              newComment={newComment}
              setNewComment={setNewComment}
              onAddComment={handleAddComment}
              isAddingComment={isAddingComment}
              editingCommentId={editingCommentId}
              setEditingCommentId={setEditingCommentId}
              editingCommentText={editingCommentText}
              setEditingCommentText={setEditingCommentText}
              onStartEditComment={handleStartEditComment}
              onSaveEditComment={handleSaveEditComment}
              onCancelEditComment={handleCancelEditComment}
              onDeleteComment={handleDeleteComment}
              setSelectedImage={setSelectedImage}
              currentLang={i18n.language} // 🎯 [Prop]
            // 🎯 [Refactor] Modal drag logic now internal to SpotDetailModal
            />
          )
        )
      }

      {/* 🎯 [NEW] 만료일 정보 팝업 - 갱신 조건 안내 */}
      {
        showExpiryInfoModal && (
          <div style={{
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(0,0,0,0.5)',
            zIndex: 15000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }} onClick={() => setShowExpiryInfoModal(false)}>
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                background: 'white',
                borderRadius: '16px',
                padding: '24px',
                maxWidth: '320px',
                textAlign: 'center'
              }}
            >
              <div style={{ fontSize: '2.5rem', marginBottom: '12px' }}>⏰</div>
              <h3 style={{ margin: '0 0 16px', fontSize: '1.1rem', color: '#1F2937' }}>
                {t(expiryInfoType === 'post' ? SPOT_MESSAGES.RENEWAL_TITLE_POST : SPOT_MESSAGES.RENEWAL_TITLE_STORE)}
              </h3>
              <p style={{ margin: '0 0 24px', color: '#6B7280', lineHeight: 1.6, fontSize: '0.95rem' }}>
                {t(expiryInfoType === 'post' ? SPOT_MESSAGES.RENEWAL_DESC_POST : SPOT_MESSAGES.RENEWAL_DESC_STORE)}
              </p>
              <button
                onClick={() => setShowExpiryInfoModal(false)}
                style={{
                  width: '100%',
                  padding: '12px',
                  background: '#6C5CE7',
                  color: 'white',
                  border: 'none',
                  borderRadius: '10px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  fontSize: '0.95rem'
                }}
              >
                {t(SPOT_MESSAGES.CONFIRM)}
              </button>
            </div>
          </div>
        )
      }

      {/* 🎯 [Fix] Alert Modal should be on TOP of Reg Modal */}


      {
        modalProps && createPortal(
          <ModalOverlay data-modal-open="true" style={{ zIndex: 99999 }}>
            <ModalContent>
              <ModalMessage>{modalProps.message}</ModalMessage>
              <ModalActions>
                {modalProps.onCancel && <ModalButton $secondary onClick={modalProps.onCancel}>{t(SPOT_MESSAGES.CANCEL)}</ModalButton>}
                <ModalButton onClick={modalProps.onConfirm}>{t(SPOT_MESSAGES.CONFIRM)}</ModalButton>
              </ModalActions>
            </ModalContent>
          </ModalOverlay>,
          document.body
        )
      }
      {/* 🎯 Global Loading Overlay */}
      {(isSubmitting || isAddingComment) && <LoadingOverlay message={t('spot_loading')} />}
      {/* 🎯 [NEW] Currency Modal - SPOT/STAR/Ticket 팝업 */}
      <CurrencyModal
        isOpen={showCurrencyModal}
        onClose={() => setShowCurrencyModal(false)}
        spotPoints={spotPoints}
        starPoints={userPoints}
        ticketCount={ticketCount}
      />

      {/* 🎯 [NEW] Announcement List Modal - 공지사항 리스트 (아코디언 형태) */}
      <AnnouncementListModal
        isOpen={showAnnouncementModal}
        onClose={() => setShowAnnouncementModal(false)}
      />

      <ReferralModal
        isOpen={showReferralModal}
        onClose={() => setShowReferralModal(false)}
      />

      {/* 🎯 [NEW] Point Spot Reward Modal */}
      <PointSpotRewardModal
        isOpen={showPointSpotModal}
        onClose={() => setShowPointSpotModal(false)}
        onClaimBasic={() => handleClaimPointSpot('basic')}
        onClaimAd={() => handleClaimPointSpot('ad')}
        isLoading={isClaimingPoint}
      />

      <FadeGradient />

      {/* 🎯 [UI] Lightbox Overlay with Close Button */}
      {
        selectedImage && (
          <div
            onClick={() => setSelectedImage(null)}
            style={{
              position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
              background: 'rgba(0,0,0,0.9)', zIndex: 20000,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              cursor: 'zoom-out'
            }}
          >
            {/* Close Button */}
            <button
              onClick={() => setSelectedImage(null)}
              style={{
                position: 'absolute', top: '40px', right: '20px',
                background: 'rgba(255,255,255,0.2)', color: 'white',
                border: 'none', borderRadius: '50%',
                width: '40px', height: '40px',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                cursor: 'pointer', zIndex: 20001
              }}
            >
              <IoClose size={24} />
            </button>

            <img
              src={selectedImage}
              alt="Full view"
              style={{ maxWidth: '100%', maxHeight: '90vh', objectFit: 'contain' }}
              onClick={e => e.stopPropagation()}
            />
          </div>
        )
      }

      {/* 🎯 [NEW] Premium Radius Modal */}
      <PremiumRadiusModal
        isOpen={showPremiumModal}
        onConfirm={handlePremiumConfirm}
        onCancel={() => setShowPremiumModal(false)}
      />
    </Container >
  );
};

export default SpotGoMain;

// 🎯 [Refactor] All styled components moved to styles/SpotStyles.js
